<template>
    <div id="conetendor-principal" class="container-fluid">
        <div id="encabezados">
            <h1>EDICIÓN DE CONTENIDO</h1>
            <h4>Busque el contenido de la página web y realice los cambios necesarios</h4>
        </div>
        <div id="secciones-contenedor" class="row">
            <div class="col-xs-4 col-sm-4 col-md-4 col-lg-3 pr-2 pt-4">
                <CFiltrosDeBusqueda id="seccion-filtros-busqueda"
                v-on:BusquedaContenidos="evtBusquedaContenidos"></CFiltrosDeBusqueda>
            </div>
            <div class="col-xs-9 col-sm-9 col-md-9 col-lg-9 pr-2 pt-4">
                <div>
                    <div id="titulo-resultados">
                        <div v-if="!ordenarContenidos.mostrar" class="form-inline justify-content-between">
                            <h4>Listado de contenidos {{ seccionDeContenidos }}</h4>
                            <div class="form-inline">
                                <button v-if="contenidos.listaDeContenidosBD.length > 0" @click="evtProcesoObtenerLinksArchviosDeContenidos" type="button" class="btn btn-sm btn btn-light"><i class="fas fa-link"></i></button>
                                <button v-if="this.campoRequeridoEsValido(seccionDeContenidos) && contenidos.listaDeContenidosBD.length > 1" 
                                    @click="evtMostrarModalOrdenDeContenidos" type="button" class="ml-2 btn btn-sm btn btn-light"><i class="fas fa-sort-numeric-up"></i></button>
                            </div>
                        </div>
                        <div v-if="ordenarContenidos.mostrar" class="form-inline justify-content-between">
                             <h4>Ordenamiento de contenidos {{ seccionDeContenidos }}</h4>
                             <div class="form-inline">
                                <button v-if="contenidos.listaDeContenidosBD.length > 0" @click="evtProcesoObtenerLinksArchviosDeContenidos" type="button" class="btn btn-sm btn btn-light"><i class="fas fa-link"></i></button>
                                <button v-if="ordenarContenidos.mostrar" @click="evtOcultarOdenamientoContenidos" type="button" class="ml-2 btn btn-sm btn btn-light"><i class="fas fa-window-close"></i></button>
                             </div>
                        </div>
                    </div>
                    <div v-if="ordenarContenidos.mostrar" class="area">
                        <div id="contenedor-ordenamiento-contenidos" class="">
                            <COrdenamientoDeContenidos
                                id="lista-ordenamiento-contenidos"
                                :listaDeContenidos="contenidos.listaDeContenidosBD"
                                :esParaEdicion="true"
                                :camposRequeridosDeFormulario="formulario.camposRequeridosFormulario"
                                :paginaWebId="contenidos.filtrosBusqueda.paginaWebId"
                                :seccionId="contenidos.filtrosBusqueda.secccionId"
                                :ref="ordenarContenidos.REF"
                                v-on:ActualizarContenidos="evtActualizarContenidosOrdenamiento"
                                :key="ordenarContenidos.KEY + ordenarContenidos.contRender"></COrdenamientoDeContenidos>
                        </div>
                        <!-- <hr style="height:2px;border:none;color:#FFF;background-color:#fff; margin-top:13px;"/> -->
                        <div class="form-inline justify-content-end mt-4">
                            <button type="button" class="btn btn-light mr-2" @click="evtOrdenamientoAlfabeticoDeContenidos"><i class="fas fa-sort-alpha-down"></i>&nbsp;Ordenar alfabéticamente</button>
                            <button type="button" class="btn btn-primary text-center" @click="evtGuardarOrdenDeContenidos"><i class="fas fa-save"></i>&nbsp;Guardar Orden</button>
                        </div>
                    </div>
                    <div v-show="!ordenarContenidos.mostrar" id="tabla-resultados-edicion-SICPO" class='table-responsive'>
                         <div v-if="contenidos.contenidosSeleccionados.length > 1" id="accion-estatus-contenidos" class="form-inline justify-content-end">
                            <h6 @click="evtMostrarModalCambioEstatus" class="mr-3"><i class="fas fa-exchange-alt"></i>&nbsp;&nbsp;Cambiar estatus</h6>
                        </div>
                        <table
                            class="table table-striped table-light table-hover"
                            id="tabla-contenidos"              
                            data-toggle="table"
                            data-pagination="true"
                            data-undefined-text="Sin información"
                            data-maintain-selected="true"  
                            data-page-size = "5"
                            data-page-list="[5,10,20]"
                            data-click-to-select="false"
                            data-search="true">
                            <thead class="thead-dark">
                                <tr>
                                    <th id="tabla-contenidos-seleccionar-todo" data-halign="center" data-width="5" data-align="center" data-checkbox="true"></th>
                                    <th data-halign="center" data-width="10" data-align="center" data-field="ContenidoDeLaPaginaWebId" data-sortable="true">
                                        Folio
                                    </th>
                                    <!-- <th data-halign="center" data-width="15" data-align="center" data-field="EsComunicado" data-sortable="true">
                                        Es comunicado
                                    </th>
                                    <th data-halign="center" data-width="20" data-align="center" data-field="EsDisposicionEspecial" data-sortable="true">
                                        Es disposicion especial
                                    </th> -->
                                    <th id="columna-texto-descriptivo-VEDC-pw" data-events="operateEvents" data-halign="center" data-width="35" data-align="center" data-field="textoDescriptivo.texto" data-sortable="true">
                                        Texto del Contenido
                                    </th>
                                    <th data-halign="center" data-width="15" data-align="center" data-field="UltimaModificacion" data-sortable="true">
                                        Última modificación
                                    </th>
                                    <!-- <th data-halign="center" data-width="20" data-align="center" data-field="FechaDeRegistro" data-sortable="true">
                                        Fecha de Publicación
                                    </th> -->
                                    <th data-events="operateEvents" id="switch-contenido-activo" data-width="10" data-field="EstaActivo.html" data-halign="center" data-align="center">
                                        Activo
                                    </th>
                                    <th data-events="operateEvents" data-width="15" :data-formatter="this.formateadorHTMLAccionesContenidos()" data-halign="center" data-align="center">
                                        Acciones
                                    </th>
                                </tr>
                            </thead>
                        </table>
                    </div>
                </div>
            </div>
        </div>
        <!-- MODAL FORMULARIO DE CONTENIDO -->
        <div class="modal align-middle" tabindex="-1" data-backdrop="static" data-keyboard="false"  id="formulario-contenido">
            <div class="modal-dialog modal-lg modal-dialog-centered">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title">Formulario de edición, {{ folioContenido }}</h5>
                        <button  id="btn-cerrar-formulario-contenido" @click="evtCerrarFormulario" class="close" data-dismiss="modal"><i class="fas fa-times-circle"></i></button>
                    </div>
                    <div class="modal-body pl-4 pr-4">
                        <div class="form-group">
                            <div class="form-inline justify-content-between">
                                <i>Realiza las modificaciones necesarias</i>
                                <!-- REGRESAR SECCION FORMULARIO PRINCIPAL -->
                                <button v-show="inputRequerido != null && formulario.mostrarSeccionDeArchivos" type="button" 
                                    @click="evtCambiosRealizadosEnArchivos" class="btn btn-light pl-2 pr-2"><i class="fas fa-check-circle"></i>&nbsp;Cambios realizados en archivos</button>
                                <!-- GUARDAR MODIFICACIONES DE CONTENIDO -->
                                <button v-show="inputRequerido != null && !formulario.mostrarSeccionDeArchivos" type="button" 
                                    @click="evtGuardarModificacionesEnContenido" class="btn btn-light pl-2 pr-2"><i class="fas fa-save"></i>&nbsp;Guardar cambios</button>
                            </div>
                        </div>
                        <div v-if="(!formulario.mostrarSeccionDeArchivos) && 
                                   (formulario.mostrarErroresInput && !this.validacionesFormulario(this.formulario.VALIDACIONES.camposDeContenido, true))" class="form-group">
                            <div id="contenedor-error-formulario">
                                <h6><i class="fas fa-exclamation-triangle text-danger"></i>&nbsp;Error en Formulario</h6>
                                <span style="text-align: justify; display:block;">{{ formulario.mensajeError }}</span>
                            </div>
                        </div>
                        <div v-if="((inputRequerido != null && inputRequerido.listaDeArchivos.requerido) && formulario.mostrarSeccionDeArchivos) && 
                                   (formulario.mostrarErroresInput && !this.validacionesFormulario(this.formulario.VALIDACIONES.agregarArchivoEnListado, true))" class="form-group">
                            <div id="contenedor-error-formulario">
                                <h6><i class="fas fa-exclamation-triangle text-danger"></i>&nbsp;Error en Formulario</h6>
                                <span style="text-align: justify; display:block;">{{ formulario.mensajeError }}</span>
                            </div>
                        </div>
                        <div v-if="inputRequerido != null && !formulario.mostrarSeccionDeArchivos" class="form-group contenedor-color-negro container-fluid">
                            <!-- TOGGLE PARA COMUNICADOS -->
                            <div v-show="inputRequerido.tipoDeFormulario == 'comunicado'" class="form-group">
                                <div class="row">
                                    <!-- SWITCH CRACATER INFORMATIVO -->
                                    <div v-show="inputRequerido.opcionesComunicadoUrgente.requerido" class="btn-group btn-group-toggle col-xs-6 col-sm-6 col-md-6 col-lg-6 pr-3" data-toggle="buttons">
                                        <label :class="[(!formulario.esUrgente) ? 'btn btn-secondary active' :'btn btn-secondary']" @click="formulario.esUrgente = false">
                                            <input type="radio" name="options" id="radioCaracterUrgente" autocomplete="off" checked>Carácter Informativo
                                        </label>
                                        <label :class="[(formulario.esUrgente) ? 'btn btn-secondary active' :'btn btn-secondary']" @click="formulario.esUrgente = true">
                                            <input type="radio" name="options" id="radioCaracterInformativo" autocomplete="off">Carácter Urgente
                                        </label>
                                    </div>
                                    <!-- SWITCH PIN -->
                                    <div :class="(inputRequerido.opcionesComunicadoUrgente.requerido) ? 
                                                    'btn-group btn-group-toggle col-xs-6 col-sm-6 col-md-6 col-lg-6 pr-3 justify-content-end' : 
                                                    'btn-group btn-group-toggle col-xs-12 col-sm-12 col-md-12 col-lg-12 pr-3'" data-toggle="buttons">
                                        <label :class="[(formulario.esPin) ? 'btn btn-secondary active' :'btn btn-secondary']" @click="formulario.esPin = true">
                                            <input type="radio" name="options" id="radioEsPin" autocomplete="off"  checked><i class="fas fa-thumbtack"></i>&nbsp;&nbsp;Agregar pin
                                        </label>
                                        <label :class="[(!formulario.esPin) ? 'btn btn-secondary active' :'btn btn-secondary']" @click="formulario.esPin = false">
                                            <input type="radio" name="options" id="radioNoEsPin" autocomplete="off" >Sin pin
                                        </label>
                                    </div>
                                </div>
                            </div>
                            <!-- TITULO -->
                            <div v-show="inputRequerido.titulo.requerido" class="form-group">
                                <h6>Ingrese un título</h6>
                                <input v-model="formulario.titulo" type="text" id="titulo_contenido" 
                                    :class="[!this.campoRequeridoEsValido(formulario.titulo) && formulario.mostrarErroresInput ? 'form-control border border-danger': 'form-control']" placeholder="Ingrese el título" />
                            </div>
                            <!-- NOMBRE DEL PRESIDENTE/A -->
                            <div v-show="inputRequerido.nombrePresidente.requerido" class="form-group">
                                <h6>Ingrese el nombre de la persona</h6>
                                <input v-model="formulario.nombrePresidente" type="text" id="nombrePresidente_contenido" 
                                    :class="[!this.campoRequeridoEsValido(formulario.nombrePresidente) && formulario.mostrarErroresInput ? 'form-control border border-danger': 'form-control']" placeholder="Ingrese el nombre de la persona" />
                            </div>
                            <!-- CAMPOS DESIGANDO POR -->
                            <div v-show="inputRequerido.catalogoPoderes.requerido" class="form-group">
                                <div class="row justify-content-between">
                                    <div class="form-group col-9 col-sm-9 col-md-9 col-lg-9 pr-0 mb-0">
                                        <h6>Designado por</h6>
                                        <CSelectGenerico class="p-0 m-0" 
                                            v-on:valorParaElPadre="cambioCatalogoPoderes" 
                                            :prefijo="enumeraciones.etiquetasDeHTML.Select" 
                                            :tipo="enumeraciones.tiposDeSelect.Seleccione" 
                                            :idDelInput="formulario.catalogoPoderes.ID" 
                                            :valorDefinido="formulario.catalogoPoderes.valorDefinido" 
                                            :key="formulario.catalogoPoderes.KEY + formulario.catalogoPoderes.contRender" 
                                            :elementos="formulario.catalogoPoderes.PODERES" 
                                            :mansajeValorDefinidoPlural="formulario.catalogoPoderes.MENSAJE_PLURAL" 
                                            :mansajeValorDefinidoSingular="formulario.catalogoPoderes.SINGULAR"></CSelectGenerico>
                                    </div>
                                    <!-- SWITCH SUPLENTE -->
                                    <div class="form-group col-3 col-sm-3 col-md-3 col-lg-3 pr-0 mb-0">
                                        <h6>Es suplente</h6>
                                        <div class="btn-group btn-group-toggle mb-0 pr-0" data-toggle="buttons">
                                            <label id="descargaRadio-toggle" :class="[formulario.esSuplente ? 'btn btn-secondary active' : 'btn btn-secondary']" @click="formulario.esSuplente = true">
                                                <input type="radio" name="options" id="radioArchivoDeDescarga" autocomplete="off"  checked>Si
                                            </label>
                                            <label id="vinculoRadio-toggle" :class="[!formulario.esSuplente ? 'btn btn-secondary active' : 'btn btn-secondary']" @click="formulario.esSuplente = false">
                                                <input type="radio" name="options" id="radioLinkAOtraPagina" autocomplete="off" >No
                                            </label>
                                        </div>
                                    </div> 
                                </div>
                            </div>
                            <!-- PERIODO DE TIEMPO DE PRESIDENTE/A -->
                            <div v-show="inputRequerido.rangoPresidente.requerido" class="form-group">
                                <h6>Ingrese el periodo de tiempo en el que fue presidente</h6>
                                <input v-model="formulario.rangoPresidente" type="text" id="rangoPresidente_contenido" 
                                    :class="[!this.campoRequeridoEsValido(formulario.rangoPresidente) && formulario.mostrarErroresInput? 'form-control border border-danger': 'form-control']" placeholder="2014 - 2020" />
                            </div>
                            <!-- DESCRIPCION CONTENIDO -->
                            <div v-show="inputRequerido.textoDelContenido.requerido" class="form-group">
                                <h6>Ingrese una descripción</h6>
                                <textarea  v-model="formulario.descripcion" type="text" :rows="formulario.numerofilasDescripcion" id="descripcion_contenido" 
                                    :class="[!this.campoRequeridoEsValido(formulario.descripcion) && formulario.mostrarErroresInput ? 'form-control border border-danger': 'form-control']" placeholder="Ingrese una descripción" />
                                <hr v-if="inputRequerido.imagenesObligaciones.requerido"/>
                            </div>
                            <!-- IMAGEN DE CONTENIDO -->
                            <div v-if="inputRequerido.imagenDeContenido.requerido && this.campoRequeridoEsValido(formulario.imagenDeContenido.ruta) && !formulario.imagenDeContenido.utilizoSubidor" class="form-group">
                                <div class="form-inline">
                                    <i class="pr-2">Imagen actual: {{ formulario.imagenDeContenido.nombre }}</i>
                                    <button type="button" class="btn btn-sm btn-success" @click="evtDescargarArchivo(formulario.imagenDeContenido.ruta)"><i class="fas fa-file-download"></i>&nbsp;Descargar</button>
                                    <button v-if="!formulario.imagenDeContenido.conVisualizador" type="button" class="btn btn-sm btn-light ml-2" @click="formulario.imagenDeContenido.conVisualizador = true"><i class="fas fa-eye"></i>&nbsp;Ver</button>
                                    <button v-if="formulario.imagenDeContenido.conVisualizador" type="button" class="btn btn-sm btn-light ml-2" @click="formulario.imagenDeContenido.conVisualizador = false"><i class="fas fa-eye-slash"></i>&nbsp;Ocultar</button>
                                </div>
                            </div>
                            <div v-show="formulario.imagenDeContenido.conVisualizador && !formulario.imagenDeContenido.utilizoSubidor" class="form-group">
                                <img id="imagen-contenido-visor" />
                            </div>
                            <div v-show="inputRequerido.imagenDeContenido.requerido" class="form-group">
                                <h6>Seleccione la imagen del contenido</h6>
                                <input type="file" id="imagen_contenido" 
                                    :class="[!this.campoRequeridoEsValido(formulario.imagenDeContenido.archivo) && formulario.mostrarErroresInput  ? 'form-control border border-danger': 'form-control']" 
                                    v-on:change="evtSubidorImagen($event)" :accept="formulario.imagenDeContenido.EXTENSIONES" />
                                <hr/>
                            </div>
                            <!-- LISTADO DE IMAGENES OBLIGACIONES -->
                            <div v-show="formulario.imagenesObligaciones.lista.length > 0 && inputRequerido.imagenesObligaciones.requerido" class="form-group">
                                <h6>Seleccione una imagen para la obligacion</h6>
                                <CListaDeImagenes :class="[!this.campoRequeridoEsValido(formulario.imagenesObligaciones.imagenSeleccionada) && formulario.mostrarErroresInput  ? 'border border-danger': '']" 
                                    :idDivPadre="formulario.imagenesObligaciones.DIV_PADRE_ID"
                                    :estilosExtraDiv="'display: inline-block; border-radius:8px; overflow-y: auto; background-color:#212529; max-height: 212px;'" 
                                    :estilosExtraUl="'margin-left: 3.5em; margin-bottom: 1em;'" 
                                    v-on:cargarImagenes="recargarImagenesPredeterminadas" 
                                    v-on:valorParaElPadre="evtSeleccionImagenObligaciones" 
                                    :idListaDeImagenes="formulario.imagenesObligaciones.ID" 
                                    :listaDeImagenes="formulario.imagenesObligaciones.lista"
                                    :ref="formulario.imagenesObligaciones.REF"
                                    :key="formulario.imagenesObligaciones.KEY + formulario.imagenesObligaciones.contRender"></CListaDeImagenes>
                                <hr v-if="inputRequerido.archivosDeContenido.requerido" />
                            </div>
                            <!-- ARCHIVO O VINCULO -->
                            <div v-if="inputRequerido.archivosDeContenido.requerido" class="form-group">
                                <!-- SWITCH ES ARCHIVO O VINCULO -->
                                <div v-if="formulario.archivos.lista.length < 2 && !inputRequerido.listaDeArchivos.requerido" class="btn-group btn-group-toggle form-group" data-toggle="buttons">
                                    <label id="descargaRadio-toggle" :class="[formulario.archivos.descargaRadio ? 'btn btn-secondary active' : 'btn btn-secondary']"
                                           @click="formulario.archivos.descargaRadio = true, formulario.vinculo.vinculoRadio = false">
                                        <input type="radio" name="options" id="radioArchivoDeDescarga" autocomplete="off"  checked>Archivo
                                    </label>
                                    <label id="vinculoRadio-toggle" :class="[formulario.vinculo.vinculoRadio ? 'btn btn-secondary active' : 'btn btn-secondary']"
                                           @click="formulario.archivos.descargaRadio = false, formulario.vinculo.vinculoRadio = true">
                                        <input type="radio" name="options" id="radioLinkAOtraPagina" autocomplete="off" >Vínculo a otra página
                                    </label>
                                </div>
                                <!-- OPCION DESCRAGA DE ARCHIVO (SOLO CUANDO ES UN ARCHIVO) -->
                                <div class="form-group mt-1" 
                                    v-if="(formulario.archivos.lista.length == 1 && formulario.archivos.descargaRadio) && 
                                          (!inputRequerido.listaDeArchivos.requerido && !formulario.archivos.utilizoSubidor) &&
                                           !formulario.archivos.esVinculo">
                                    <div class="form-inline">
                                        <i class="pr-2">Archivo actual: {{ formulario.archivos.lista[0].NombreBase }}</i>
                                        <button type="button" class="btn btn-sm btn-success" @click="evtDescargarArchivo(formulario.archivos.lista[0].RutaDelArchivo)"><i class="fas fa-file-download"></i>&nbsp;Descargar</button>
                                    </div>
                                </div>
                                <!-- INPUTS PARA VINCULO A OTRA PAGINA -->
                                <div v-show="(formulario.vinculo.vinculoRadio && !formulario.archivos.descargaRadio) && formulario.archivos.lista.length < 2" class="form-group">
                                     <!-- TEXTO DEL VINCULO -->
                                    <div class="form-group">
                                        <h6>Ingrese texto del vínculo</h6>
                                        <input v-model="formulario.vinculo.texto" type="text" id="texto_vinculo_archivo" 
                                            :disabled="formulario.esTextoDeVinculoPredeterminado"
                                            :class="[!this.campoRequeridoEsValido(formulario.vinculo.texto) && formulario.mostrarErroresInput ? 'form-control border border-danger': 'form-control']" placeholder="Ingrese texto del vínculo para el archivo" />
                                    </div>
                                    <!-- URL DEL VINCULO -->
                                    <div class="form-group">
                                        <h6>Ingrese el vínculo a otra página (URL)</h6>
                                        <input v-model="formulario.vinculo.url" type="text" id="vinculo_contenido" 
                                            :class="[!this.campoRequeridoEsValido(formulario.vinculo.url) && formulario.mostrarErroresInput ? 'form-control border border-danger': 'form-control']" placeholder="Ingrese el vínculo" />
                                    </div>
                                </div>
                                <!-- INPUTS PARA ARCHIVO -->
                                <div v-show="(formulario.archivos.descargaRadio && !formulario.vinculo.vinculoRadio) && !inputRequerido.listaDeArchivos.requerido" class="form-group">
                                    <!-- SWITCH ARCHIVO ES VINCULO -->
                                    <div v-show="inputRequerido.archivoConVinculo.requerido" class="btn-group btn-group-toggle form-group" data-toggle="buttons">
                                        <label :class="[!formulario.archivos.esVinculo ? 'btn btn-secondary active' : 'btn btn-secondary']" 
                                            @click="formulario.archivos.esVinculo = false, formulario.mostrarErroresInput = false, formulario.mensajeError = null">
                                            <input type="radio" name="options" id="radioArchivoDeDescarga" autocomplete="off"  checked>Archivo de descarga
                                        </label>
                                        <label :class="[formulario.archivos.esVinculo ? 'btn btn-secondary active' : 'btn btn-secondary']" 
                                            @click="formulario.archivos.esVinculo = true, formulario.mostrarErroresInput = false, formulario.mensajeError = null">
                                            <input type="radio" name="options" id="radioLinkAOtraPagina" autocomplete="off" >Vínculo del archivo
                                        </label>
                                    </div>
                                     <!-- TEXTO DEL VINCULO ARCHIVO -->
                                    <div class="form-group">
                                        <h6>Ingrese texto del vínculo</h6>
                                        <input v-model="formulario.archivos.vinculo" type="text" id="texto_vinculo_archivo_1"
                                            :disabled="formulario.esTextoDeVinculoPredeterminado" 
                                            :class="[!this.campoRequeridoEsValido(formulario.archivos.vinculo) && formulario.mostrarErroresInput ? 'form-control border border-danger': 'form-control']" placeholder="Ingrese texto del vínculo para el archivo" />
                                    </div>
                                    <!-- SE MUESTRA EN VISOR -->
                                    <div class="btn-group btn-group-toggle form-group" data-toggle="buttons">
                                        <label :class="[formulario.archivos.mostrarEnVisor ? 'btn btn-secondary active' : 'btn btn-secondary']" 
                                            @click="evtToggleMostrarEnVisor({ mostrar: true })">
                                            <input type="radio" name="options" id="radioMostrarEnVisor" autocomplete="off"  checked>Mostrar en visor
                                        </label>
                                        <label :class="[!formulario.archivos.mostrarEnVisor ? 'btn btn-secondary active' : 'btn btn-secondary']" 
                                            @click="evtToggleMostrarEnVisor({ mostrar: false })">
                                            <input type="radio" name="options" id="radioNoMostrarEnVisor" autocomplete="off" >No Mostrar en visor
                                        </label>
                                    </div>
                                    <!-- SUBIDOR DE ARCHIVO -->
                                    <div v-show="!formulario.archivos.esVinculo" class="form-group">
                                        <h6>Seleccione el archivo de descarga</h6>
                                        <input type="file" id="archivo-descarga-contenido" ref="" 
                                            :class="[!this.campoRequeridoEsValido(formulario.archivos.archivo) && formulario.mostrarErroresInput ? 'form-control border border-danger': 'form-control']"
                                            v-on:change="evtSubidorArchivoContenido($event)" :accept="formulario.archivos.EXTENSIONES" />
                                    </div>
                                    <div v-show="formulario.archivos.esVinculo" class="form-group">
                                        <h6>Ingrese el vínculo(URL)</h6>
                                        <input v-model="formulario.archivos.url" type="text" id="vinculo_archivo" 
                                            :class="[!this.campoRequeridoEsValido(formulario.archivos.url) && formulario.mostrarErroresInput ? 'form-control border border-danger': 'form-control']" placeholder="Ingrese el vínculo" />
                                    </div>
                                    <!-- <div v-show="inputRequerido.listaDeArchivos.requerido && (formulario.archivos.descargaRadio && !formulario.vinculo.vinculoRadio)" class="form-group">
                                        <div class="d-flex justify-content-end"><button type="button" class="btn btn-primary"><i class="fas fa-file-upload"></i>&nbsp;&nbsp;Agregar</button></div>
                                    </div> -->  
                                </div>
                                <div v-show="inputRequerido.listaDeArchivos.requerido" class="form-group">
                                    <!-- <div v-if="formulario.archivos.lista.length < 2" class="d-flex justify-content-end"><button type="button" class="btn btn-primary"><i class="fas fa-file-upload"></i>&nbsp;&nbsp;Agregar</button></div> -->
                                    <div class="form-group">
                                        <h6 class="pr-2">Contenido cuenta con {{ formulario.archivos.lista.length }} archivos</h6>
                                        <button type="button" @click="evtMostrarTablaArchivos" class="btn btn-info"><i class="fas fa-edit"></i>&nbsp;&nbsp;Modificar lista archivos</button>
                                    </div>
                                </div>
                                <hr/>
                            </div>
                            <!-- FECHA DE PUBLICACION -->
                            <div v-if="inputRequerido.fechaDePublicacion.requerido" class="form-group">
                                <h6 v-if="formulario.esUrgente">Ingrese rango de publicación</h6>
                                <h6 v-if="!formulario.esUrgente">Ingrese fecha de publicación</h6>
                                <div class="row mt-3">
                                    <div :class="(formulario.esUrgente) ? 'form-inline col-xs-5 col-sm-5 col-md-5 col-lg-5 pr-3' : 'form-inline col-xs-12 col-sm-12 col-md-12 col-lg-12 pr-3'">
                                        <h6 v-show="formulario.esUrgente" class="pr-2">Inicio</h6>
                                        <datepicker :key="formulario.fechaPublicacion.inicio.KEY + formulario.fechaPublicacion.inicio.contRender" 
                                            :format="formulario.fechaPublicacion.DatePickerFormato"  
                                            :highlighted="formulario.fechaPublicacion.inicio.marcarFechas"
                                            :disabled-dates="formulario.fechaPublicacion.inicio.fechasDeshabilitadas" 
                                            v-model="formulario.fechaPublicacion.inicio.fecha"
                                            @selected="evtSeleccionDeFechaDtPk"  
                                            :value="formulario.fechaPublicacion.inicio.fechaDefault" 
                                            :bootstrap-styling="true"
                                            :calendar-button="true"
                                            calendar-button-icon="far fa-calendar-alt" 
                                            name="fecha" 
                                            :language="formulario.fechaPublicacion.lenguaje"></datepicker>
                                    </div>
                                    <div v-show="formulario.esUrgente" class="form-inline col-xs-5 col-sm-5 col-md-5 col-lg-5 pr-3 justify-content-start">
                                        <h6 class="pr-2">Fin </h6>
                                        <datepicker :key="formulario.fechaPublicacion.fin.KEY + formulario.fechaPublicacion.fin.contRender" 
                                            :format="formulario.fechaPublicacion.DatePickerFormato"  
                                            :highlighted="formulario.fechaPublicacion.fin.marcarFechas"
                                            :disabled-dates="formulario.fechaPublicacion.fin.fechasDeshabilitadas" 
                                            v-model="formulario.fechaPublicacion.fin.fecha"
                                            @selected="evtSeleccionDeFechaDtPk"  
                                            :value="formulario.fechaPublicacion.fin.fechaDefault" 
                                            :bootstrap-styling="true"
                                            :calendar-button="true"
                                            calendar-button-icon="far fa-calendar-alt"  
                                            :class="{'texto-negro': true}" name="fecha" 
                                            :language="formulario.fechaPublicacion.lenguaje"></datepicker>
                                    </div>
                                </div>
                                <hr v-if="inputRequerido.disposicionEspecial.requerido"/>
                            </div> 
                            <!-- INPUTS DISPOSICIONES ESPECIALES -->
                            <div v-show="inputRequerido.disposicionEspecial.requerido" class="form-group">
                                <div v-show="inputRequerido.tipoDeFormulario == 'comunicado'" class="form-group">
                                    <div class="btn-group btn-group-toggle form-group" data-toggle="buttons">
                                        <label :class="[formulario.esDisposicionEspecial ? 'btn btn-secondary active' : 'btn btn-secondary']" @click="formulario.esDisposicionEspecial = true">
                                            <input type="radio" name="options" id="radioEsDisposicionEspecial" autocomplete="off"  checked>Es disposición especial
                                        </label>
                                        <label :class="[!formulario.esDisposicionEspecial ? 'btn btn-secondary active' : 'btn btn-secondary']" @click="formulario.esDisposicionEspecial = false">
                                            <input type="radio" name="options" id="radioNoEsDisposicionEspecial" autocomplete="off" >No es disposición especial
                                        </label>
                                    </div>
                                    <!-- CATALOGO DE SUBMENU -->
                                    <div class="form-group">
                                        <C006Submenus v-show="formulario.esDisposicionEspecial" 
                                            :class="[!this.campoRequeridoEsValido(formulario.catalogoSubmenu.valorDefinido) && formulario.mostrarErroresInput ? 'border border-danger p-0 m-0': 'p-0 m-0']" 
                                            v-on:valorParaElPadre="evtCambioTipoSubmenu" 
                                            :prefijo="enumeraciones.etiquetasDeHTML.Select" 
                                            :tipo="enumeraciones.tiposDeSelect.Seleccione" 
                                            :idDelInput="formulario.catalogoSubmenu.ID" 
                                            :parametros="formulario.catalogoSubmenu.parametros" 
                                            :valorDefinido="formulario.catalogoSubmenu.valorDefinido" 
                                            :key="formulario.catalogoSubmenu.KEY + formulario.catalogoSubmenu.contRender"></C006Submenus>
                                    </div>
                                </div>
                                <div v-show="formulario.esDisposicionEspecial || inputRequerido.tipoDeFormulario != 'comunicado'" class="form-group">
                                    <!-- <br v-if="obtenerCamposRequeridosEnFormulario.tipoDeFormulario == 'comunicado'"> -->
                                    <h6>Ingrese título del submenu</h6>
                                    <input v-model="formulario.tituloSubMenu" type="text" id="texto_titulo_submenu" 
                                        :class="[!this.campoRequeridoEsValido(formulario.tituloSubMenu) && formulario.mostrarErroresInput ? 'form-control border border-danger': 'form-control']" placeholder="Ingrese un título para el submenu" />
                                </div>
                            </div>
                        </div>
                        <!-- SECCION DE ARCHIVOS -->
                        <div v-show="inputRequerido != null && formulario.mostrarSeccionDeArchivos"  class="form-group">
                            <div class="form-group contenedor-color-negro container-fluid">
                                <!-- <div class="form-group">
                                    
                                    <div class="btn-group btn-group-toggle form-group" data-toggle="buttons">
                                        <label id="descargaRadio-toggle" :class="[formulario.archivos.descargaRadio ? 'btn btn-secondary active' : 'btn btn-secondary']"
                                            @click="formulario.archivos.descargaRadio = true, formulario.vinculo.vinculoRadio = false">
                                            <input type="radio" name="options" id="radioArchivoDeDescarga" autocomplete="off"  checked>Archivo
                                        </label>
                                        <label id="vinculoRadio-toggle" :class="[formulario.vinculo.vinculoRadio ? 'btn btn-secondary active' : 'btn btn-secondary']"
                                            @click="formulario.archivos.descargaRadio = false, formulario.vinculo.vinculoRadio = true">
                                            <input type="radio" name="options" id="radioLinkAOtraPagina" autocomplete="off" >Vínculo a otra página
                                        </label>
                                    </div>
                                </div> -->
                                
                                <!-- <div v-show="formulario.vinculo.vinculoRadio && !formulario.archivos.descargaRadio" class="form-group">
                                        
                                    <div class="form-group">
                                        <h6>Ingrese texto del vínculo</h6>
                                        <input v-model="formulario.vinculo.texto" type="text" id="texto_vinculo_archivo" 
                                            :class="[!this.campoRequeridoEsValido(formulario.vinculo.texto) && formulario.mostrarErroresInput ? 'form-control': 'form-control']" placeholder="Ingrese texto del vínculo para el archivo" />
                                    </div>
                                    
                                    <div class="form-group">
                                        <h6>Ingrese el vínculo a otra página (URL)</h6>
                                        <input v-model="formulario.vinculo.url" type="text" id="vinculo_contenido" 
                                            :class="[!this.campoRequeridoEsValido(formulario.vinculo.url) && formulario.mostrarErroresInput ? 'form-control border border-danger': 'form-control']" placeholder="Ingrese el vínculo" />
                                    </div>
                                </div> -->
                                <!-- INPUTS PARA ARCHIVO -->
                                <div v-show="formulario.archivos.descargaRadio && !formulario.vinculo.vinculoRadio" class="form-group">
                                    <!-- SWITCH ARCHIVO ES VINCULO -->
                                    <div v-show="inputRequerido != null && inputRequerido.archivoConVinculo.requerido" class="btn-group btn-group-toggle form-group" data-toggle="buttons">
                                        <label :class="[!formulario.archivos.esVinculo ? 'btn btn-secondary active' : 'btn btn-secondary']" 
                                            @click="formulario.archivos.esVinculo = false, formulario.mostrarErroresInput = false, formulario.mensajeError = null">
                                            <input type="radio" name="options" id="radioArchivoDeDescarga" autocomplete="off"  checked>Archivo de descarga
                                        </label>
                                        <label :class="[formulario.archivos.esVinculo ? 'btn btn-secondary active' : 'btn btn-secondary']" 
                                            @click="formulario.archivos.esVinculo = true, formulario.mostrarErroresInput = false, formulario.mensajeError = null">
                                            <input type="radio" name="options" id="radioLinkAOtraPagina" autocomplete="off" >Vínculo del archivo
                                        </label>
                                    </div>
                                     <!-- TEXTO DEL VINCULO ARCHIVO -->
                                    <div class="form-group">
                                        <h6>Ingrese texto del vínculo</h6>
                                        <input v-model="formulario.archivos.vinculo" type="text" id="texto_vinculo_archivo_2" 
                                            :disabled="formulario.esTextoDeVinculoPredeterminado"
                                            :class="[!this.campoRequeridoEsValido(formulario.archivos.vinculo) && formulario.mostrarErroresInput ? 'form-control border border-danger': 'form-control']" placeholder="Ingrese texto del vínculo para el archivo" />
                                    </div>
                                    <!-- SUBIDOR DE ARCHIVO -->
                                    <div v-show="!formulario.archivos.esVinculo" class="form-group">
                                        <h6>Seleccione el archivo de descarga</h6>
                                        <input type="file" id="archivo-descarga-contenido" ref="" 
                                            :class="[!this.campoRequeridoEsValido(formulario.archivos.archivo) && formulario.mostrarErroresInput ? 'form-control border border-danger': 'form-control']"
                                            v-on:change="evtSubidorArchivoContenido($event)" :accept="formulario.archivos.EXTENSIONES" />
                                    </div>
                                    <div v-show="formulario.archivos.esVinculo" class="form-group">
                                        <h6>Ingrese el vínculo(URL)</h6>
                                        <input v-model="formulario.archivos.url" type="text" id="vinculo_archivo_seccion" 
                                            :class="[!this.campoRequeridoEsValido(formulario.archivos.url) && formulario.mostrarErroresInput ? 'form-control border border-danger': 'form-control']" placeholder="Ingrese el vínculo" />
                                    </div>
                                    <hr v-if="inputRequerido != null && !inputRequerido.listaDeArchivos.requerido" style="height:2px;border:none;color:#FFF;background-color:#fff; margin-top:1px;"/> 
                                </div>
                                <div v-show="inputRequerido != null && inputRequerido.listaDeArchivos.requerido" class="form-group">
                                    <div class="d-flex justify-content-end">
                                        <button type="button" @click="evtAgregarArchivoListaDeArchivosContenido" class="btn btn-primary"><i class="fas fa-plus-square"></i>&nbsp;&nbsp;Agregar</button>
                                    </div>
                                    <hr style="height:2px;border:none;color:#FFF;background-color:#fff; margin-top:13px;"/>
                                </div>
                                <div v-if="formulario.archivos.archivosSeleccionados.filter(a => a.ArchivoDeContenidoDeLaPaginaWebId > 0).length > 1" class="">
                                    <div class="form-inline justify-content-start">
                                        <h6 class="pr-2">Estatus de archivos: </h6>
                                        <!-- SWITCH ACTIVACION VARIOS ARCHIVOS -->
                                        <div class="btn-group btn-group-toggle mt-2" data-toggle="buttons">
                                            <label :class="[formulario.archivos.activacionMultiple ? 'btn btn-secondary active' : 'btn btn-secondary']" 
                                                @click="formulario.archivos.activacionMultiple = true">
                                                <input type="radio" name="options" id="archivoActivoRadio" autocomplete="off"  checked>Activo
                                            </label>
                                            <label :class="[!formulario.archivos.activacionMultiple ? 'btn btn-secondary active' : 'btn btn-secondary']" 
                                                @click="formulario.archivos.activacionMultiple = false">
                                                <input type="radio" name="options" id="archivoInactivoRadio" autocomplete="off" >Inactivo
                                            </label>
                                        </div>
                                        <i class="fas fa-check-square ml-2 cambio-multiple-archivos-activacion" @click="evtCambioMultipleDeEstatusEnArchivos"></i>
                                    </div>
                                </div>
                                <!-- TABLA ARCHIVOS DE CONTENIDO -->
                                <div id="archivos-contenido-edicion-SICPO" class='table-responsive form-group'>
                                    <table
                                        class="table table-striped table-light table-hover"
                                        id="tabla-archivos-contenido"              
                                        data-toggle="table"
                                        data-pagination="true"
                                        data-undefined-text="Sin información"  
                                        data-page-size = "2"
                                        data-page-list="[1,2]"
                                        data-click-to-select="false"
                                        data-search="true">
                                        <thead class="thead-dark">
                                            <tr>
                                                <th data-halign="center" data-width="5" data-align="center" data-checkbox="true"></th>
                                                <th data-halign="center" data-width="30" data-align="center" data-field="NombreBase" data-sortable="true">
                                                    Nombre
                                                </th>
                                                <th data-events="operateEvents" data-width="35" data-field="tipoDeVisualizacion.html" data-halign="center" data-align="center">
                                                    Archivo
                                                </th>
                                                <th data-events="operateEvents" id="switch-archivo-activo" data-width="35" data-field="Estatus" data-sortable="true" data-halign="center" data-align="center">
                                                    Estatus
                                                </th>
                                            </tr>
                                        </thead>
                                    </table>
                                </div>
                            </div>
                        </div>
                    </div>             
                </div>
            </div>
        </div>
        <!-- MODAL COFIRMACION -->
        <div class="modal align-middle" tabindex="-1" data-backdrop="static" data-keyboard="false"  id="modal-informativo">
            <div class="modal-dialog modal-lg">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title">{{ modalInformativo.titulo }}</h5>
                    </div>
                    <div class="modal-body pl-4 pr-4">
                        <div class="form-group">
                            <h6>{{ modalInformativo.mensaje }}</h6>
                            <!-- <div class="form-inline justify-content-end">
                                <button type="button" class="btn btn-primary mr-2" @click="modalInformativo.funcionConfirmar"><i class="fas fa-check"></i>&nbsp;&nbsp;Confirmar</button>
                                <button type="button" class="btn btn-primary" @click="modalInformativo.funcionCancelar"><i class="fas fa-times"></i>&nbsp;&nbsp;Cancelar</button>
                            </div> -->
                        </div>
                        <div class="row mt-4">
                            <div class="col-6 pr-1 pl-1"><button type="button" class="btn btn-block btn-primary mr-2" @click="modalInformativo.funcionConfirmar"><i class="fas fa-check"></i>&nbsp;&nbsp;Confirmar</button></div>
                            <div class="col-6 pr-1 pl-1"><button type="button" class="btn btn-block btn-primary" @click="modalInformativo.funcionCancelar"><i class="fas fa-times"></i>&nbsp;&nbsp;Cancelar</button></div>
                        </div>
                    </div>             
                </div>
            </div>
        </div>
        <!-- MODAL CAMBIO DE ESTATUS -->
       <!--  <div class="modal align-middle" tabindex="-1" data-backdrop="static" data-keyboard="false"  id="modal-cambio-estatus">
            <div class="modal-dialog modal-lg">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title">Cambio de estatus</h5>
                        <button  id="btn-cerrar-modal-cambio-estatus" class="close" data-dismiss="modal"><i class="fas fa-times-circle"></i></button>
                    </div>
                    <div class="modal-body pl-4 pr-4">
                        <div class="form-group contenedor-color-negro">
                            <div class="form-inline justify-content-center"> 
                                <h6 class="pr-2">Estatus activo:</h6>
                                <label class="switch">
                                    <input id="switch-cambio-estatus-modal" type="checkbox">
                                    <div class="slider"></div>
                                </label>
                            </div>
                        </div>
                        <div class="form-inline justify-content-end">
                            <button type="button" class="btn btn-sm btn-primary" @click="evtCambiarEstatusContenidos"><i class="fas fa-save"></i>&nbsp;&nbsp;Guardar</button>
                        </div>
                    </div>             
                </div>
            </div>
        </div> -->
        <!-- MODAL V2 -->
         <div class="modal align-middle" tabindex="-1" data-backdrop="static" data-keyboard="false"  id="modal-cambio-estatus">
            <div class="modal-dialog modal-lg">
                <div class="modal-content">
                    <!-- <div class="modal-header">
                        <h5 class="modal-title">Cambio de estatus</h5>
                        <button  id="btn-cerrar-modal-cambio-estatus" class="close" data-dismiss="modal"><i class="fas fa-times-circle"></i></button>
                    </div> -->
                    <div class="modal-body pl-4 pr-4">
                        <div class="form-group">
                            <div class="form-inline justify-content-center mb-3">
                                <i v-if="activarVariosContenidos" class="fas fa-eye icono-activacion-contenidos"></i>
                                <i v-if="!activarVariosContenidos" class="fas fa-eye-slash icono-activacion-contenidos"></i>
                            </div>
                            <div class="form-inline justify-content-center text-center mb-2">
                                <h4 v-if="!activarVariosContenidos">El contenido se dejara de mostrar en la pagina web</h4>
                                <h4 v-if="activarVariosContenidos">El contenido se mostrara en la pagina web</h4>
                            </div>
                            <div class="form-inline justify-content-center"> 
                                <h6 class="pr-2">Estatus activo:</h6>
                                <label class="switch">
                                    <input id="switch-cambio-estatus-modal" type="checkbox" @change="evtSwitchActivacionVariosContenidos">
                                    <div class="slider"></div>
                                </label>
                            </div>
                        </div>
                        <!-- <div class="form-inline justify-content-end">
                            <button type="button" class="btn btn-primary" @click="evtCambiarEstatusContenidos"><i class="fas fa-save"></i>&nbsp;&nbsp;Guardar</button>
                        </div> -->
                        <div class="row mt-4">
                            <div class="col-6 pr-1 pl-1 acciones-activacion-contenidos"><button type="button" class="btn btn-block btn-primary" @click="evtCerrarModalActivacion"><i class="fas fa-times"></i>&nbsp;&nbsp;Cancelar</button></div>
                            <div class="col-6 pr-1 pl-1 acciones-activacion-contenidos"><button type="button" class="btn btn-block btn-primary" @click="evtCambiarEstatusContenidos"><i class="fas fa-save"></i>&nbsp;&nbsp;Guardar</button></div>
                        </div>
                    </div>             
                </div>
            </div>
        </div>
         <!-- MODAL ORDENAMIENTO DE CONTENIDOS -->
       <!--  <div class="modal align-middle" tabindex="-1" data-backdrop="static" data-keyboard="false"  id="modal-ordenamiento-contenidos">
            <div class="modal-dialog modal-lg">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title">Ordenamiento de contenidos</h5>
                        <button  id="btn-cerrar-modal-ordenamiento-contenidos" @click="ordenarContenidos.mostrar = false" class="close" data-dismiss="modal"><i class="fas fa-times-circle"></i></button>
                    </div>
                    <div class="modal-body pl-4 pr-4">
                        <div class="lista-contenidos ">
                            <COrdenamientoDeContenidos v-if="ordenarContenidos.mostrar"
                                :listaDeContenidos="contenidos.listaDeContenidosBD"
                                :esParaEdicion="true"
                                :camposRequeridosDeFormulario="formulario.camposRequeridosFormulario"
                                :paginaWebId="contenidos.filtrosBusqueda.paginaWebId"
                                :seccionId="contenidos.filtrosBusqueda.secccionId"
                                :key="ordenarContenidos.KEY + ordenarContenidos.contRender"></COrdenamientoDeContenidos>
                        </div>
                    </div>             
                </div>
            </div>
        </div> -->
    </div>
</template>
<script>
import enumeraciones from '@/../static/js/enumeraciones'
import enumeraciones_sicpo from "@/../static/js/enumeraciones/sicpo.js";
import CFiltrosDeBusqueda from '@/components/SICPO/PaginaWeb/EdicionDeContenido/CFiltrosDeBusqueda.vue';
import axios from 'axios'
import api from '@/../static/js/api'
import comun from "@/../static/js/comun"
import moment from 'moment';
import CSelectGenerico from '@/components/SICPO/Comun/CSelectGenerico.vue'
import CListaDeImagenes from '../../Comun/CListaDeImagenes.vue'
import COrdenamientoDeContenidos from '@/components/SICPO/PaginaWeb/EdicionDeContenido/COrdenamientoDeContenidos.vue';
import C006Submenus from '../../Catalogos/C006Submenus.vue'
import Datepicker from 'vuejs-datepicker';

export default {
    components: {
        CFiltrosDeBusqueda: CFiltrosDeBusqueda,
        C006Submenus,
        Datepicker,
        CSelectGenerico,
        CListaDeImagenes,
        COrdenamientoDeContenidos
    },
    data() {
        return {
            enumeraciones_sicpo,
            enumeraciones,
            modalInformativo: {
                titulo: 'Mensaje del sistema',
                mensaje: '',
                funcionConfirmar: () => {},
                funcionCancelar: () => {}
            },
            contenidos: {
                listaDeContenidosBD: [],
                listaDeContenidos: [],
                fechas: {
                    FORMATO: 'YYYY-MM-DD'
                },
                filtrosBusqueda: null,
                contenidoSeleccionado: null,
                contenidosSeleccionados: [],
                mostrarTextoDelVinculo: false
            },
            ordenarContenidos: {
                mostrar: false,
                alturaContenedor: 100,
                KEY: 'KEYOrdenamientoContenidosVEDC',
                REF: 'REFOrdenamientoContenidosVEDC',
                contRender: 0
            },
            formulario: {
                 mostrarSeccionDeArchivos: false,
                 camposRequeridosFormulario: null,
                 esPin: false,
                 titulo: null,
                 textoInicialTitulosComunicados: null,
                 nombrePresidente: null,
                 rangoPresidente: null,
                 mostrarErroresInput: false,
                 esSuplente: false,
                 descripcion: null,
                 numerofilasDescripcion: 3,
                 esTextoDeVinculoPredeterminado: false,
                 imagenDeContenido: {
                     EXTENSIONES: '.JPEG,.JPG,.PNG',
                     nombre: null,
                     archivo: null,
                     ruta: null,
                     conVisualizador: false,
                     IDENTIFICADOR: 'IMAGEN_CONTENIDO',
                     utilizoSubidor: false
                 },
                 imagenesObligaciones: {
                     DIV_PADRE_ID: 'DIVPImagenesPredeterminadasVEDC',
                     ID: 'LIMGObligacionesVEDC',
                     KEY: 'KLIMGObligacionesVEDC',
                     REF: 'RLIMGObligacionesVEDC',
                     contRender: 0,
                     lista: [],
                     imagenSeleccionada: null
                 },
                 archivos: {
                     EXTENSIONES: '.PDF,.XLSX,.XLSB,.ZIP',
                     ES_NUEVO: 'NUEVO',
                     descargaRadio: true,
                     archivo: null,
                     vinculo: null,
                     url: null,
                     lista: [],
                     identificadoresDeArchivos: [],
                     esVinculo: false,
                     contador: 1,
                     utilizoSubidor: false,
                     archivoSeleccionado: null,
                     archivosSeleccionados: [],
                     activacionMultiple: true,
                     esVinculoExterno: false,
                     mostrarEnVisor: false
                 },
                 vinculo: {
                     texto: null,
                     url: null,
                     vinculoRadio: false
                 },
                 esUrgente: false,
                 fechaPublicacion: {
                    DatePickerFormato: 'yyyy-MM-dd',
                    lenguaje:{
                        language: 'es',
                        months: ['Enero', 'Febrero', 'Marzo', 'Abril', 'Mayo', 'Junio', 'Julio', 'Agosto', 'Septiembre', 'Octubre', 'Noviembre', 'Diciembre'],
                        monthsAbbr: ['Ene', 'Feb', 'Mar', 'Abr', 'May', 'Jun', 'Jul', 'Ago', 'Sep', 'Oct', 'Nov', 'Dic'],
                        days: ['D','L', 'M', 'M', 'J', 'V', 'S'],
                        rtl: false,
                        ymd: 'yyyy-MM-dd',
                        yearSuffix: ''
                    },
                    inicio: {
                        KEY: 'DTPCKinicioVEDC',
                        contRender: 0,
                        fecha: new Date(),
                        fechaSeleccionada: 0,
                        fechaDefault: new Date(),
                        marcarFechas: {
                            customPredictor: (dia) => {
                                let DIA_SELECCIONADO = moment(dia).format('YYYY-MM-DD');
                                let FECHA_FINAL = moment(this.formulario.fechaPublicacion.fin.fecha).format('YYYY-MM-DD');
                                let FECHA_INICIAL = moment(this.formulario.fechaPublicacion.inicio.fecha).format('YYYY-MM-DD');
                                if(this.formulario.esUrgente) {
                                    const DIA_VALIDO = (DIA_SELECCIONADO == FECHA_INICIAL); 
                                    return DIA_VALIDO;
                                }
                                else {
                                    const RANGO_DIAS_VALIDO = (DIA_SELECCIONADO >= FECHA_INICIAL && DIA_SELECCIONADO <= FECHA_FINAL);
                                    return RANGO_DIAS_VALIDO;
                                }
                            },
                            includeDisabled: false
                        },
                        fechasDeshabilitadas: {
                            customPredictor: (dia) => {
                                let DIA_SELECCIONADO = moment(dia).format('YYYY-MM-DD');
                                let FECHA_ACTUAL = moment().format('YYYY-MM-DD');
                                const DIA_VALIDO = (DIA_SELECCIONADO < FECHA_ACTUAL);
                                return DIA_VALIDO; 
                            }
                        }
                    },
                    fin: {
                        KEY: 'DTPCKfinVEDC',
                        contRender: 0,
                        fecha: new Date(),
                        fechaSeleccionada: 0,
                        fechaDefault: new Date(),
                        marcarFechas: { 
                            customPredictor: (dia) => {
                                let DIA_SELECCIONADO = moment(dia).format('YYYY-MM-DD');
                                let FECHA_FINAL = moment(this.formulario.fechaPublicacion.fin.fecha).format('YYYY-MM-DD');
                                let FECHA_INICIAL = moment(this.formulario.fechaPublicacion.inicio.fecha).format('YYYY-MM-DD');
                                const DIAS_VALIDOS = (DIA_SELECCIONADO >= FECHA_INICIAL && DIA_SELECCIONADO <= FECHA_FINAL); 
                                return DIAS_VALIDOS;
                            },
                            includeDisabled: false
                        },
                        fechasDeshabilitadas: {
                            customPredictor: (dia) => {
                                let DIA_SELECCIONADO = moment(dia).format('YYYY-MM-DD');
                                let FECHA_INICIAL = moment(this.formulario.fechaPublicacion.inicio.fecha).format('YYYY-MM-DD');
                                const DIA_VALIDO = (DIA_SELECCIONADO < FECHA_INICIAL);
                                return DIA_VALIDO;
                            }
                        }
                    }
                 },
                 esDisposicionEspecial: false,
                 catalogoSubmenu: {
                     ID: 'CSubmenuVEDC',
                     EY: 'CPoderesVEDC',
                     contRender: 0,
                     valorDefinido: -1,
                     parametros: {SubmenuId: null, MenuId:40, PaginaWebId:null, SubmenuIdDelQuePertenezco:null, SubmenuIdQueMePertenece:null, ConInactivos:false, ConMenu:false, ConMenusLosSubmenus:false, ConSubmenusQueMePertenecen:false, ConTodosLosSubmenusQueMePertenecen: false, ConTodasLasPaginasWebDelSubmenu:false, ConSubmenuDelQueDesciende:false, ConPaginasWeb:false, ConOrdenamiento:false, ConOrdenamientoDeLosSubmenus:false, SoloPermiteSubirContenido:true},
                     seleccion: null
                 },
                 tituloSubMenu: null,
                 catalogoPoderes: {
                     ID: 'CPoderesVEDC',
                     KEY: 'CPoderesVEDC',
                     contRender: 0,
                     valorDefinido: -1,
                     MENSAJE_PLURAL: 'los poderes que designan',
                     MENSAJE_SINGULAR: 'el poder que designa',
                     PODERES: [ {valor: 1, nombre:'Poder Ejecutivo Estatal'}, {valor: 2, nombre:'Poder Judicial'}, {valor: 3, nombre:'Poder Legislativo'} ],
                     poderQueDesigna: null,
                 },
                 mensajeError: null,
                 VALIDACIONES: {
                     agregarArchivoEnListado: { llave: 1},
                     agregarArchivoUrlEnListado: { llave: 2 },
                     camposDeContenido: { llave: 3 }
                 }
            },
            CASOS_LIMPIEZA_FECHAS: { INICIO: 1, FIN: 2, TODAS: 3 },
            esActivacionMultipleContenidos: false
        }
    },
    methods: {
        evtToggleMostrarEnVisor: function({ mostrar }) { debugger
            this.formulario.archivos.mostrarEnVisor = mostrar;
            this.formulario.archivos.archivo.MostrarEnVisor = mostrar;
            this.contenidos.contenidoSeleccionado.ArchivosDeContenidoDeLaPaginaWeb[0].MostrarEnVisor = mostrar;
        },
        evtCerrarModalActivacion: function() {
            $('#modal-cambio-estatus').modal("hide");
        },
        evtSwitchActivacionVariosContenidos: function() {
            this.esActivacionMultipleContenidos = $('#switch-cambio-estatus-modal').is(":checked");
        },
        evtProcesoObtenerLinksArchviosDeContenidos: async function() {
            try {
                comun.SeEstaCargandoInformacion(true);
                await Promise.resolve(this.generarYDescargarArchivoTxtLinksContenidos());
                comun.SeEstaCargandoInformacion(false);
            }
            catch(e) {
                comun.mensajeDeAlerta('Se produjo un error al generar el archivo, vuelve a intentarlo.');
                console.log(e);
                comun.SeEstaCargandoInformacion(false);
            }
        },
        generarYDescargarArchivoTxtLinksContenidos: async function() {
            const CONTENIDOS_LINKS = await Promise.resolve(this.crearStrLinksDeContenidos());
            console.log('CONTENIDOS_LINKS::',CONTENIDOS_LINKS);
            const ARCHIVO_CON_LINKS = new Blob([CONTENIDOS_LINKS],{ type: "text/plain;charset=utf-8" });
            const CREADOR_URL = window.URL || window.webkitURL;
            const URL_ARCHIVO_DESCARGA = CREADOR_URL.createObjectURL(ARCHIVO_CON_LINKS);
            var a = document.createElement("a");
            a.href = URL_ARCHIVO_DESCARGA;
            a.download = 'LinksContenidos.txt';
            document.body.appendChild(a);
            a.click();
        },
        crearStrLinksDeContenidos: async function() {
            let filasArchivos = [];
            let filasArchivoStr = null;
            const NOMBRE_SECCION_CONTENIDOS = await Promise.resolve(this.obtenerNombreDeLaSeccionContenidos());
            const ES_TEXTO_DEL_VINCULO = this.contenidos.listaDeContenidosBD.filter(cobj => cobj.TipoEstatusDelContenido.TipoEstatusDelContenidoId != 4).some(c => !this.campoRequeridoEsValido(c.TextoDelContenido));
            if(this.campoRequeridoEsValido(NOMBRE_SECCION_CONTENIDOS))
                filasArchivos.push(`LINKS DE CONTENIDOS ${ NOMBRE_SECCION_CONTENIDOS }`);
            this.contenidos.listaDeContenidosBD.filter(cobj => cobj.TipoEstatusDelContenido.TipoEstatusDelContenidoId != 4).forEach(cbd => {
                let { ContenidoDeLaPaginaWebId, TextoDelContenido, ArchivosDeContenidoDeLaPaginaWeb, Vinculo, TextoDelVinculo } = cbd;
                let textoAMostrar = (ES_TEXTO_DEL_VINCULO) ? TextoDelVinculo : TextoDelContenido;
                filasArchivos.push(`CONTENIDO:`);
                filasArchivos.push(` #Folio: ${ ContenidoDeLaPaginaWebId } | TextoDelContenido: ${ textoAMostrar }`);
                if(this.campoRequeridoEsValido(Vinculo)) {
                    filasArchivos.push(`  VINCULO:`);
                    filasArchivos.push(`   url: ${ Vinculo }`);
                }
                else if (this.campoRequeridoEsValido(ArchivosDeContenidoDeLaPaginaWeb) && ArchivosDeContenidoDeLaPaginaWeb.length > 0) {
                    filasArchivos.push(`  ARCHIVOS: #${ ArchivosDeContenidoDeLaPaginaWeb.length }`);
                    let contador = 1;
                    ArchivosDeContenidoDeLaPaginaWeb.filter(a => a.Activo).forEach(ac => {
                        let archivoObj = Object.create(ac);
                        const { NombreBase, RutaDelArchivo } = archivoObj;
                        let rutaFormateada = RutaDelArchivo;
                        if(rutaFormateada.includes("\\themisfs")) {
                            rutaFormateada = RutaDelArchivo.replace(/\\themisfs/g, enumeraciones_sicpo.Recursos.IpAccesoServidorArchivos);
                            rutaFormateada = rutaFormateada.replace(/\\/g, "/");
                            rutaFormateada = rutaFormateada.substring(1); 
                        }
                        filasArchivos.push(`   ${ contador }| LINK: ${ rutaFormateada }`);
                    }); 
                }
            });
            if(filasArchivos.length > 0) {
                filasArchivoStr = filasArchivos.join('\n');
            }
            return filasArchivoStr;
        },
        obtenerNombreDeLaSeccionContenidos: async function() {
            let nombreSeccion = null;
            const CONTENIDO_OBJ = this.contenidos.listaDeContenidosBD.filter(cobj => cobj.TipoEstatusDelContenido.TipoEstatusDelContenidoId != 4).find(c => c.SeccionDeContenido != null);
            console.log('CONTENIDO_OBJ::',CONTENIDO_OBJ);
            if(this.campoRequeridoEsValido(CONTENIDO_OBJ) && this.campoRequeridoEsValido(CONTENIDO_OBJ.SeccionDeContenido)) {
                const { NombreDeLaSeccion } = CONTENIDO_OBJ.SeccionDeContenido;
                nombreSeccion =  `SECCION: ${ NombreDeLaSeccion }`;
            }
            return nombreSeccion;
        },
        evtOrdenamientoAlfabeticoDeContenidos: async function() {
            const MOSTRAR_MENSAJE = false;
            const MENSAJE_DE_ORDENAMIENTO = await Promise.resolve(this.OrdenamientoAlfabeticoDeContenidosBD(MOSTRAR_MENSAJE));
            this.evtActualizarContenidosOrdenamiento(MENSAJE_DE_ORDENAMIENTO);
        },
        OrdenamientoAlfabeticoDeContenidosBD: async function(mostrarMensaje) {
            try {
                const SERVIDOR = api.conexion;
                const METODO_API_OBTENER = api.SICPO.sistema.paginaweb.ediciondecontenido.OrdenamientoAlfabeticoDeContenidos;;
                let urlApi = SERVIDOR + METODO_API_OBTENER;
                let peticionAPI = {
                    EsComunicado: this.paginaRequiereComunicado(this.contenidos.filtrosBusqueda.paginaWebId),
                    PaginaWebId: this.contenidos.filtrosBusqueda.paginaWebId,
                    SeccionId: this.contenidos.filtrosBusqueda.secccionId,
                    OrdenAscendente: false,
                    esPrueba: false
                }
                let peticionArchivos = false;
                let headerPeticion = comun.CrearElHeaderDeAutorizacion(this.$store.state.Login_AutorizacionOriginal, peticionArchivos,false);
                comun.SeEstaCargandoInformacion(true);
                const PETICION_ORDENAMIENTO_ALFABETICO = await axios.post(urlApi, peticionAPI, headerPeticion);
                const DATOS_PETICION = await PETICION_ORDENAMIENTO_ALFABETICO.data;
                let { SiHayError, Error, Satisfactorio } = DATOS_PETICION;
                if (SiHayError) {
                    let mensajeError = Error.Mensaje;
                    comun.SeEstaCargandoInformacion(false);
                    console.log(mensajeError);
                    comun.mensajeDeAlerta(mensajeError, null, null);
                } 
                else {
                    comun.SeEstaCargandoInformacion(false);
                    if(mostrarMensaje)
                        comun.mensajeDeAlerta(Satisfactorio);
                    else
                        return Satisfactorio;
                }
            }
            catch(excepcion) {
                comun.SeEstaCargandoInformacion(false);
                console.log(excepcion);
                comun.mensajeDeAlerta(enumeraciones.error.E500, null, null);
            }
        },
        evtActualizarContenidosOrdenamiento: function(mensajeDeActualizacion) {
            const ES_DESPUES_DE_ACTUALIZACION = this.campoRequeridoEsValido(mensajeDeActualizacion);
            this.obtenerContenidos(this.contenidos.filtrosBusqueda, ES_DESPUES_DE_ACTUALIZACION, mensajeDeActualizacion);
        },
        evtGuardarOrdenDeContenidos: function() {
            this.$nextTick(() => {
                this.$refs[this.ordenarContenidos.REF].guardarOrdenDeContenidos();
            });
        },
        evtCambioMultipleDeEstatusEnArchivos: function() { 
            this.formulario.archivos.archivosSeleccionados.filter(a => a.ArchivoDeContenidoDeLaPaginaWebId > 0).forEach(asel => {
                asel.Activo = this.formulario.archivos.activacionMultiple;
            });
            this.$nextTick(async () => {
                $("#tabla-archivos-contenido").bootstrapTable('uncheckAll');
                await Promise.resolve(this.persistirSwitchArchivosActivos());
            });
        },
        guardarModificacionesBD: async function(peticionAPI, desdeFormulario) {
            try {
                const SERVIDOR = api.conexion;
                const METODO_API_EDITAR = api.SICPO.sistema.paginaweb.ediciondecontenido.EditarContenidoPaginaWeb;
                let urlApi = SERVIDOR + METODO_API_EDITAR;
                let peticionArchivos = true;
                let headerPeticion = comun.CrearElHeaderDeAutorizacion(this.$store.state.Login_AutorizacionOriginal, peticionArchivos,false);
                if(desdeFormulario)
                    $("#formulario-contenido").modal('hide');
                comun.SeEstaCargandoInformacion(true);
                const PETICION_IMAGENES_OBLIGACIONES = await axios.post(urlApi, peticionAPI, headerPeticion);
                const DATOS_PETICION = await PETICION_IMAGENES_OBLIGACIONES.data;
                let { SiHayError, Error, contenidosDeLaPaginaWeb, Satisfactorio } = DATOS_PETICION;
                if (SiHayError) {
                    let mensajeError = Error.Mensaje;
                    comun.SeEstaCargandoInformacion(false);
                    console.log(mensajeError);
                    comun.mensajeDeAlerta(mensajeError, null, null);
                    if(desdeFormulario)
                        $("#formulario-contenido").modal('show');
                    return null;
                } 
                else {
                    comun.SeEstaCargandoInformacion(false);
                    this.limpiarFormulario();
                    return Satisfactorio;
                }
            }
            catch(excepcion) {
                comun.SeEstaCargandoInformacion(false);
                console.log(excepcion);
                comun.mensajeDeAlerta(enumeraciones.error.E500, null, null);
                if(desdeFormulario)
                    $("#formulario-contenido").modal('show');
            }
        },
        evtGuardarModificacionesEnContenido: async function() {
            const MOSTRAR_ESTATUS_DE_VALIDACION = true;
            const TIPO_VALIDACION = this.formulario.VALIDACIONES.camposDeContenido;
            if(this.validacionesFormulario(TIPO_VALIDACION, MOSTRAR_ESTATUS_DE_VALIDACION)) {
                console.log('pasoValidacion');
                let contenidoObj = this.contenidos.listaDeContenidosBD.find(c => c.ContenidoDeLaPaginaWebId == this.contenidos.contenidoSeleccionado.ContenidoDeLaPaginaWebId);
                const CONTENIDO_ORIGINAL =  Object.create(contenidoObj);
                console.log('CONTENIDO_ORIGINAL::',CONTENIDO_ORIGINAL);
                let peticionAPI = await Promise.resolve(this.crearPeticionCambiosContenido(contenidoObj));
                for (var pair of peticionAPI.entries()) {
                    console.log(pair[0]+ ', ',pair[1]); 
                } 
                const DESDE_FORMULARIO = true;
                let mensajeSatisfactorio = await Promise.resolve(this.guardarModificacionesBD(peticionAPI, DESDE_FORMULARIO));
                if(this.campoRequeridoEsValido(mensajeSatisfactorio)) {
                    comun.mensajeDeAlerta(mensajeSatisfactorio);
                    this.ordenarContenidos.mostrar = false;
                    const ES_DESPUES_DE_ACTUALIZACION = false;
                    const MENSAJE_DE_ACTUALIZACION = '';
                    this.obtenerContenidos(this.contenidos.filtrosBusqueda, ES_DESPUES_DE_ACTUALIZACION, MENSAJE_DE_ACTUALIZACION);
                }
            }
        },
        crearPeticionCambiosContenido: async function(contenidoObj) {
            let peticion = new FormData();
            /* let CONTENIDO_OBJ_ORIGINAL = this.contenidos.listaDeContenidosBD.find(c => c.ContenidoDeLaPaginaWebId == this.contenidos.contenidoSeleccionado.ContenidoDeLaPaginaWebId);
            let contenidoObj =  Object.create(CONTENIDO_OBJ_ORIGINAL); */
            const { paginaWebId, secccionId } = this.contenidos.filtrosBusqueda;
            const SECCION_DESIGNADO_POR_ID = 3;
            const ES_SECCION_DESIGANDO_POR = (secccionId == SECCION_DESIGNADO_POR_ID);

            contenidoObj.TextoDelContenido = await Promise.resolve(this.construirDescripcionContenido(paginaWebId,ES_SECCION_DESIGANDO_POR));
            contenidoObj.TextoDelVinculo = await Promise.resolve(this.construirTextoDelVinculoContenido());
            contenidoObj.Vinculo = await Promise.resolve(this.construirVinculoContenido());
            // fechas de contenido
            contenidoObj.FechaDePublicacion = moment(this.formulario.fechaPublicacion.inicio.fecha).format(this.contenidos.fechas.FORMATO);
            if(this.formulario.esUrgente) {
                contenidoObj.FechaDePublicacionFinal = moment(this.formulario.fechaPublicacion.fin.fecha).format(this.contenidos.fechas.FORMATO);
            }
            // fin fechas
            /* funcionalidad para el caso de valor default en titulo de comunicados
            contenidoObj.Titulo = (this.campoRequeridoEsValido(this.formulario.textoInicialTitulosComunicados)) 
                ? `${ this.formulario.textoInicialTitulosComunicados } ${ this.formulario.titulo }` : this.formulario.titulo; */
            contenidoObj.Titulo = this.formulario.titulo;
            const LLAVE_IMAGEN = (this.formulario.imagenDeContenido.utilizoSubidor) ? this.formulario.imagenDeContenido.IDENTIFICADOR: 
                (this.inputRequerido.imagenesObligaciones.requerido) ? this.formulario.imagenesObligaciones.imagenSeleccionada.llave : contenidoObj.RutaDeImagen;
            contenidoObj.RutaDeImagen = LLAVE_IMAGEN;
            contenidoObj.EsUrgente = this.formulario.esUrgente;
            contenidoObj.EsDisposicionEspecial = this.formulario.esDisposicionEspecial || paginaWebId == 28;
            //contenido.tipoIcono = null;
            contenidoObj.Submenu = await Promise.resolve(this.construirSubmenu(contenidoObj));
            contenidoObj.EsPin = this.formulario.esPin;
            // si es vinculo a otra pagina reemplaza el archivo
            contenidoObj.ArchivosDeContenidoDeLaPaginaWeb = await Promise.resolve(this.construirListaArchivosDelContenido());
            //ciclo de archivos con llaves
            this.formulario.archivos.identificadoresDeArchivos.forEach(ia => {
                let archivoDeContenido = contenidoObj.ArchivosDeContenidoDeLaPaginaWeb.find(ac => ac.RutaDelArchivo == ia.llave);
                if(this.campoRequeridoEsValido(archivoDeContenido)) {
                    peticion.append(ia.llave,ia.archivo);
                }
            });
            console.log('IMAGENENNEE::',this.formulario.imagenDeContenido.utilizoSubidor);
            if(this.campoRequeridoEsValido(this.formulario.imagenDeContenido.archivo) && this.formulario.imagenDeContenido.utilizoSubidor)
                peticion.append(this.formulario.imagenDeContenido.IDENTIFICADOR,this.formulario.imagenDeContenido.archivo);
            peticion.append('ReferenciaArchivoImagen',this.formulario.imagenDeContenido.IDENTIFICADOR);
            peticion.append('EsImagenPredeterminada',this.inputRequerido.imagenesObligaciones.requerido);
            peticion.append('PaginaWebId',this.contenidos.filtrosBusqueda.paginaWebId);
            peticion.append('EsComunicado',this.paginaRequiereComunicado(this.contenidos.filtrosBusqueda.paginaWebId));
             peticion.append('EsContenidoConListaDeArchivos',this.inputRequerido.listaDeArchivos.requerido);
            peticion.append('Contenido',JSON.stringify(contenidoObj));
            peticion.append('EsPrueba',false); 
            return peticion;
        },
        construirListaArchivosDelContenido: async function() {
            let listaDeArchivos = [];
            let archivosObj = this.formulario.archivos.lista.map(a => ({ ...a }));
            if(!this.inputRequerido.listaDeArchivos.requerido) {
                // caso para cambio de vinculo a archivo de contenido sin archivos
                if(archivosObj.length < 1 && this.formulario.archivos.descargaRadio) {
                    let archivoContenidoObj = null;
                    if((this.campoRequeridoEsValido(this.formulario.archivos.archivo) && this.formulario.archivos.utilizoSubidor) || this.formulario.archivos.esVinculo) {
                        archivoContenidoObj = this.construirArchivoDeSubidor();
                        archivosObj.push(archivoContenidoObj);
                    }
                    listaDeArchivos = archivosObj;
                }
                else {
                    listaDeArchivos = (this.formulario.archivos.descargaRadio)
                    ? archivosObj.map(ac => {
                        let archivoContenidoObj = null;
                        if((this.campoRequeridoEsValido(this.formulario.archivos.archivo) && this.formulario.archivos.utilizoSubidor) || this.formulario.archivos.esVinculo) {
                            archivoContenidoObj = this.construirArchivoDeSubidor();
                        }
                        else {
                            archivoContenidoObj = ac;
                            if(this.campoRequeridoEsValido(archivoContenidoObj.TipoRolDeArchivoEnContenido))
                                archivoContenidoObj.TipoRolDeArchivoEnContenido.ArchivosDeContenidoDeLaPaginaWeb = (!this.campoRequeridoEsValido(ac.TipoRolDeArchivoEnContenido.ArchivosDeContenidoDeLaPaginaWeb) || ac.TipoRolDeArchivoEnContenido.ArchivosDeContenidoDeLaPaginaWeb.length < 1)
                                                                                        ? [] : ac.TipoRolDeArchivoEnContenido.ArchivosDeContenidoDeLaPaginaWeb;
                            archivoContenidoObj.TextoDelVinculo = (!this.formulario.vinculo.vinculoRadio) ? this.formulario.archivos.vinculo : this.formulario.vinculo.texto,
                            /* archivoContenidoObj.Activo = this.formulario.vinculo.vinculoRadio ? false : true; */
                            // se eliminan las propiedades que no pertenecen a la entidad ArchivoDeContenidoPaginaWeb
                            delete archivoContenidoObj['tipoDeVisualizacion'];
                            delete archivoContenidoObj['Estatus'];
                        }
                        return archivoContenidoObj;
                    }) : [];
                }
            }
            else {
                // caso para contenidos con lista de archivos
                listaDeArchivos = archivosObj.map(ac => {
                    let archivoContenidoObj = null;
                    archivoContenidoObj = ac;
                    if(this.campoRequeridoEsValido(archivoContenidoObj.TipoRolDeArchivoEnContenido))
                        archivoContenidoObj.TipoRolDeArchivoEnContenido.ArchivosDeContenidoDeLaPaginaWeb = (!this.campoRequeridoEsValido(ac.TipoRolDeArchivoEnContenido.ArchivosDeContenidoDeLaPaginaWeb) || ac.TipoRolDeArchivoEnContenido.ArchivosDeContenidoDeLaPaginaWeb.length < 1)
                                                                                ? [] : ac.TipoRolDeArchivoEnContenido.ArchivosDeContenidoDeLaPaginaWeb;
                    // se eliminan las propiedades que no pertenecen a la entidad ArchivoDeContenidoPaginaWeb
                    delete archivoContenidoObj['tipoDeVisualizacion'];
                    delete archivoContenidoObj['Estatus'];
                    return archivoContenidoObj;
                });
            }
            return listaDeArchivos;
        },
        construirArchivoDeSubidor: function() {
            // si cambia de archivo se limpia la lista de identificadores para que no duplique archivos en la peticion
            this.formulario.archivos.identificadoresDeArchivos = [];
            let ArchivoDeContenidoObj = {
                Activo: true,
                ArchivoDeContenidoDeLaPaginaWebId: -1,
                ContenidoDeLaPaginaWeb: { ContenidoDeLaPaginaWebId: this.contenidos.contenidoSeleccionado.ContenidoDeLaPaginaWebId },
                FechaDeRegistro: moment(),
                NombreBase: this.formulario.archivos.archivo.name,
                NombreEnServidor: this.formulario.archivos.archivo.name,
                RutaDelArchivo: (this.formulario.archivos.esVinculo) ? this.formulario.archivos.url :`${ this.formulario.archivos.ES_NUEVO + this.formulario.archivos.contador }`,
                TextoDelVinculo: (!this.formulario.vinculo.vinculoRadio) ? this.formulario.archivos.vinculo : this.formulario.vinculo.texto,
                TipoRolDeArchivoEnContenido: null
            }
            // solo agregar identificador cuando es un File si el archivo se carga desde un vinculo no es necesario
            if(!this.formulario.archivos.esVinculo) {
                const ARCHIVO_CON_IDENTIFICADOR = { archivo: this.formulario.archivos.archivo, llave: ArchivoDeContenidoObj.RutaDelArchivo };
                this.formulario.archivos.identificadoresDeArchivos.push(ARCHIVO_CON_IDENTIFICADOR);
            }
            return ArchivoDeContenidoObj;
        },
        construirSubmenu: async function(contenidoObj) {
            let submenu = {};
            if(this.formulario.esDisposicionEspecial) {
                if(this.campoRequeridoEsValido(contenidoObj.Submenu)) {
                    // por lo general una disposicion especial tiene un arbol de submenus cuando es comunicado(por el momento solo noticias), este metodo
                    // solo sera sera funcional cuando el submenu padre sea COVID-19, si en un futuro se agrega otro submenu para las dispoiciones especiales de 
                    // comunicados, se debera remplezar este codigo por un recorrido del arbol de submenus del comunicado hasta que encuentre el submenu padre.
                    contenidoObj.Submenu.Titulo = this.formulario.tituloSubMenu;
                    submenu = contenidoObj.Submenu;
                }
                else {
                    submenu = {
                        SubmenuId: -1,
                        Titulo: this.formulario.tituloSubMenu,
                        //[ estos valores no se modificaran solo se agregan porque la entidad no los tiene como nulables
                        ResaltarElTitulo: false,
                        EsDescarga: false,
                        SeMuestraEnVisor: false,
                        Activo: false,
                        PermiteSubirContenido: false,
                        // ]
                        SubmenuAlQuePertenezco: {
                            SubmenuId: this.formulario.catalogoSubmenu.valorDefinido,
                            //[ estos valores no se modificaran solo se agregan porque la entidad no los tiene como nulables
                            ResaltarElTitulo: false,
                            EsDescarga: false,
                            SeMuestraEnVisor: false,
                            Activo: false,
                            PermiteSubirContenido: false,
                            // ]
                        }
                    }
                }
            }
            else {
                submenu = null;
            }
            return submenu;
        },
        construirTextoDelVinculoContenido: async function() {
            let textoDelVinculo = null;
            if(!this.inputRequerido.listaDeArchivos.requerido) {
                textoDelVinculo = (this.formulario.vinculo.vinculoRadio && !this.formulario.archivos.descargaRadio) 
                    ? this.formulario.vinculo.texto : this.formulario.archivos.vinculo;
            }
            return textoDelVinculo;
        },
        construirVinculoContenido: async function() {
            let vinculo = null;
            if(!this.inputRequerido.listaDeArchivos.requerido) {
                if(this.formulario.vinculo.vinculoRadio) {
                    vinculo = this.formulario.vinculo.url;
                }
               /*  else{
                    vinculo = (this.formulario.archivos.esVinculo) ? this.formulario.archivos.url : null;
                } */
            }
            return vinculo;
        },
        construirDescripcionContenido: async function(tipoDePagina,esSeccion) { 
            // llenarDescripcionContenido: async function() { 
            let textoContenido = this.formulario.descripcion;
            let contenido = [];
            switch(true) {
                // pagina web tipo presidentes
                case tipoDePagina == 12:
                    contenido.push(this.formulario.nombrePresidente);
                    contenido.push(this.formulario.rangoPresidente);
                    textoContenido = contenido.join("¶");
                    break;
                // paginas web Magistrados del supremo tribunal de justicia y Magistrados de sala administrativa 
                case (tipoDePagina == 4 || tipoDePagina == 6):
                    const ENCABEZADO_CONTENIDO = 'Síntesis Curricular.' + "\n";
                    contenido.push(this.formulario.nombrePresidente);
                    this.formulario.vinculo.texto = this.formulario.nombrePresidente;
                    this.formulario.archivos.vinculo =  this.formulario.nombrePresidente;
                    contenido.push(ENCABEZADO_CONTENIDO);
                    contenido.push(this.formulario.descripcion);
                    textoContenido = contenido.join("\n");
                    break;
                // en este caso se trata de una seccion consejero
                case (esSeccion && tipoDePagina == 2):
                     contenido.push(this.formulario.nombrePresidente);
                     /* this.formulario.vinculo.texto = this.formulario.nombrePresidente;
                     this.formulario.archivos.vinculo =  this.formulario.nombrePresidente; */
                     let poderQuedesinaStr = this.formulario.catalogoPoderes.poderQueDesigna;
                     if(this.formulario.esSuplente){
                         poderQuedesinaStr += ' (Suplente)'
                     }
                     contenido.push(poderQuedesinaStr);
                     textoContenido = contenido.join("¶");
                    break;
                default:
            }
            return textoContenido;
        },
        evtOcultarOdenamientoContenidos: function() {
            this.ordenarContenidos.mostrar = false;
            this.contenidos.contenidoSeleccionado.ArchivosDeContenidoDeLaPaginaWeb;
        },
        evtMostrarModalOrdenDeContenidos: async function() { 
            await Promise.resolve(this.identificarCamposParaFormulario());
            this.ordenarContenidos.mostrar = true;
            this.$nextTick(() => { debugger
                const ALTURA_DE_CONTENEDOR = $('#seccion-filtros-busqueda').height();
                $('#contenedor-ordenamiento-contenidos').css({"height": (ALTURA_DE_CONTENEDOR - 80) + "px"});
                $('#contenedor-ordenamiento-contenidos').css({"maxHeight": (ALTURA_DE_CONTENEDOR - 40) + "px"});
                const ES_COMUNICADO = this.paginaRequiereComunicado(this.contenidos.filtrosBusqueda.paginaWebId);
                const NUMERO_CONTENIDOS_MOSTRAR = (ES_COMUNICADO) ? 3 : 4;
                if(this.contenidos.listaDeContenidos.length >= NUMERO_CONTENIDOS_MOSTRAR)
                    $('#contenedor-ordenamiento-contenidos').addClass('lista-contenidos');
                else
                    $('#contenedor-ordenamiento-contenidos').removeClass('lista-contenidos');
            });
        },
        evtMostrarModalCambioEstatus: function() {
            $('#modal-cambio-estatus').modal("show");
        },
        evtCambiarEstatusContenidos: async function() {
            const OPCIONES_PETICION = null;
            const PETICON_API = await Promise.resolve(this.crearPeticioParaCambioDeEstatusContenidos(OPCIONES_PETICION));
            const ES_CAMBIO_INDIVIDUAL = false;
            $('#modal-cambio-estatus').modal("hide");
            this.cambiarEstatusDeContenidosBD(PETICON_API, ES_CAMBIO_INDIVIDUAL);
        }, 
        evtCambiarEstatusContenidoIndividual: async function(evento, contenido) {
            const ID_CHECK_CONTENIDO = evento.target.getAttribute('id');
            const OPCIONES_PETICION = {
                idChekContenido: ID_CHECK_CONTENIDO,
                contenidoSel: contenido
            }
            const PETICON_API = await Promise.resolve(this.crearPeticioParaCambioDeEstatusContenidos(OPCIONES_PETICION));
            const ES_CAMBIO_INDIVIDUAL = true;
            this.cambiarEstatusDeContenidosBD(PETICON_API, ES_CAMBIO_INDIVIDUAL);
        }, 
        cambiarEstatusDeContenidosBD: async function(peticionAPI, esContenidoIndividual) {
            try {
                const SERVIDOR = api.conexion;
                const METODO_API_MODIFICAR = api.SICPO.sistema.paginaweb.ediciondecontenido.CambiarEstatusDeContenidosPaginaWeb;
                let urlApi = SERVIDOR + METODO_API_MODIFICAR;
                let peticionArchivos = false;
                let headerPeticion = comun.CrearElHeaderDeAutorizacion(this.$store.state.Login_AutorizacionOriginal, peticionArchivos,false);
                comun.SeEstaCargandoInformacion(true);
                const PETICION_ESTATUS = await axios.post(urlApi, peticionAPI, headerPeticion);
                const DATOS_PETICION = await PETICION_ESTATUS.data;
                let { SiHayError, Error, Satisfactorio, ContenidosDeLaPaginaWeb } = DATOS_PETICION;
                if (SiHayError) {
                    let mensajeError = Error.Mensaje;
                    comun.SeEstaCargandoInformacion(false);
                    console.log(mensajeError);
                    comun.mensajeDeAlerta(mensajeError, null, null);
                } 
                else {
                    await Promise.resolve(this.actualizarEstatusContenidosEnMemoria(ContenidosDeLaPaginaWeb));
                    this.limpiarModalEstatus();
                    if(esContenidoIndividual) {
                        await Promise.resolve(this.persistirSwitchAContenidosActivos());
                        comun.SeEstaCargandoInformacion(false);
                        comun.mensajeDeAlerta(Satisfactorio);
                    }
                    else {
                         const ES_DESPUES_DE_ACTUALIZACION = true;
                         this.obtenerContenidos(this.contenidos.filtrosBusqueda, ES_DESPUES_DE_ACTUALIZACION, Satisfactorio);
                         this.limpiarModalEstatus();
                    }
                }
            }
            catch(excepcion) {
                comun.SeEstaCargandoInformacion(false);
                console.log(excepcion);
                comun.mensajeDeAlerta(enumeraciones.error.E500, null, null);
            }
        },
        actualizarEstatusContenidosEnMemoria: async function(listaActualizadaEstatus) {
            // se actualiza lista con formato para la tabla
            listaActualizadaEstatus.forEach(cActlz => {
                let contenido = this.contenidos.listaDeContenidos.find(c => c.ContenidoDeLaPaginaWebId == cActlz.ContenidoDeLaPaginaWebId);
                if(this.campoRequeridoEsValido(contenido)) {
                    contenido.TipoEstatusDelContenido.TipoEstatusDelContenidoId = cActlz.TipoEstatusDelContenido.TipoEstatusDelContenidoId;
                    contenido.EstaActivo.activo = (cActlz.TipoEstatusDelContenido.TipoEstatusDelContenidoId == 2) ? true : false;
                }

                // se actualiza lista con objetos de contenido completos bd
                contenido = this.contenidos.listaDeContenidosBD.find(c => c.ContenidoDeLaPaginaWebId == cActlz.ContenidoDeLaPaginaWebId);
                if(this.campoRequeridoEsValido(contenido))
                    contenido.TipoEstatusDelContenido.TipoEstatusDelContenidoId = cActlz.TipoEstatusDelContenido.TipoEstatusDelContenidoId;
            });
            console.log('this.contenidos.listaDeContenidos::',this.contenidos.listaDeContenidos);
        },
        crearPeticioParaCambioDeEstatusContenidos: async function(opciones) {
            let peticion = {};
            const ESTATUS_ACTIVO_ID = 2;
            const ESTATUS_CANCELADO_ID = 4;
            if(this.campoRequeridoEsValido(opciones)) {
                const ES_ESTATUS_ACTIVO = $('#' + opciones.idChekContenido).is(":checked");
                const ESTATUS = (ES_ESTATUS_ACTIVO) ? ESTATUS_ACTIVO_ID : ESTATUS_CANCELADO_ID;
                let contenidoObj = {};
                contenidoObj.ContenidoDeLaPaginaWebId = opciones.contenidoSel.ContenidoDeLaPaginaWebId;
                contenidoObj.TipoEstatusDelContenido = {
                    TipoEstatusDelContenidoId: ESTATUS
                };
                // estos valores no se actualizaran solo se llenan porque no son valores nullables de la entidad, es 
                // para prevenir error en la conversion de la peticion en controller
                contenidoObj.FechaDePublicacion = opciones.contenidoSel.FechaDePublicacion;
                contenidoObj.FechaDeRegistro = opciones.contenidoSel.FechaDeRegistro;
                contenidoObj.EsDisposicionEspecial = opciones.contenidoSel.EsDisposicionEspecial;
                contenidoObj.MostrarArchivos = opciones.contenidoSel.MostrarArchivos;
                peticion.ContenidosDeLaPaginaWeb = [contenidoObj];
            }
            else {
                const ES_ESTATUS_ACTIVO = $('#switch-cambio-estatus-modal').is(":checked");
                const ESTATUS = (ES_ESTATUS_ACTIVO) ? ESTATUS_ACTIVO_ID : ESTATUS_CANCELADO_ID;
                this.contenidos.contenidosSeleccionados = this.contenidos.contenidosSeleccionados.map(csel => {
                    csel.TipoEstatusDelContenido = {
                        TipoEstatusDelContenidoId: ESTATUS
                    };
                    return csel;
                });
                console.log('entro::else::',this.contenidos.contenidosSeleccionados);
                peticion.ContenidosDeLaPaginaWeb = this.contenidos.contenidosSeleccionados;
            }
            peticion.EsComunicado = this.paginaRequiereComunicado(this.contenidos.filtrosBusqueda.paginaWebId);
            peticion.EsPrueba = false;
            return peticion;
        },
        llenarDatosEnFormulario: async function() {
            if(this.campoRequeridoEsValido(this.formulario.camposRequeridosFormulario)) {
                await Promise.resolve(this.llenarListaDeArchivosFormulario());
                await Promise.resolve(this.llenarDescripcionContenido());
                await Promise.resolve(this.llenarVinculosContenido());
                await Promise.resolve(this.llenarFechasContenido());
                await Promise.resolve(this.llenarCamposDisposicionEspecial());
                await Promise.resolve(this.llenarTituloContenido());
                await Promise.resolve(this.llenarImagenContenido());
                await Promise.resolve(this.llenarImagenPredeterminadaObligacion());
            }
        },
        llenarImagenPredeterminadaObligacion: async function() {
            const { RutaDeImagen } = this.contenidos.contenidoSeleccionado;
            if(this.formulario.imagenesObligaciones.lista.length > 0 && this.campoRequeridoEsValido(RutaDeImagen)) {
                const NOMBRE_IMAGEN = RutaDeImagen.replace(/^.*[\\\/]/, '');
                /* console.log('NOMBRE_IMAGEN::',NOMBRE_IMAGEN); */
                const IMAGEN_PREDETERMIDA_CONTENIDO = this.formulario.imagenesObligaciones.lista.find(i => {
                    return i.imagen.replace(/^.*[\\\/]/, '') == NOMBRE_IMAGEN;
                });
                this.formulario.imagenesObligaciones.imagenSeleccionada = IMAGEN_PREDETERMIDA_CONTENIDO;
                if(this.campoRequeridoEsValido(IMAGEN_PREDETERMIDA_CONTENIDO)) {
                    this.$nextTick(async () => {
                        // Se posiciona scroll en la posicion de la imagen seleccionada
                        const POSICION_IMAGEN_ELEMENTO = $("#" + IMAGEN_PREDETERMIDA_CONTENIDO.llave + 'img').offset().top;
                        // Veriifacr si el valor 400 es para todo los tipos de altura de las pantallas
                        $("#" + this.formulario.imagenesObligaciones.DIV_PADRE_ID).scrollTop(POSICION_IMAGEN_ELEMENTO - 400);
                        $("#" + IMAGEN_PREDETERMIDA_CONTENIDO.llave).trigger("click");
                        // cuando actualiza estos valores, la tabla se actualiza y pierde los valores de los switch
                        await Promise.resolve(this.persistirSwitchAContenidosActivos());
                    });
                }
            }
        },
        llenarImagenContenido: async function() {
            const { RutaDeImagen } = this.contenidos.contenidoSeleccionado;
            this.formulario.imagenDeContenido.ruta = RutaDeImagen;
            try {
                if(this.campoRequeridoEsValido(RutaDeImagen)) {
                    const METODO_DESCARGA = `${api.conexion}${api.Comun.funcion.DescargarArchivo}?rutaDelArchivo=${RutaDeImagen}`;
                    comun.SeEstaCargandoInformacion(true);
                    const PETICION_DESCARGA = await axios.get(METODO_DESCARGA, { responseType: 'blob' });
                    const IMAGEN = await PETICION_DESCARGA.data;
                    const CREADOR_URL = window.URL || window.webkitURL;
                    const URL_IMAGEN = CREADOR_URL.createObjectURL(IMAGEN);
                    this.$nextTick(() => {
                        $('#imagen-contenido-visor').attr("src", URL_IMAGEN);
                    });
                    comun.SeEstaCargandoInformacion(false);
                    this.formulario.imagenDeContenido.archivo = RutaDeImagen;
                }
            }
            catch(exeption) {
                comun.SeEstaCargandoInformacion(false);
                console.log(exeption);
            }
        },
        llenarTituloContenido: async function() {
            const { Titulo } = this.contenidos.contenidoSeleccionado;
            /* let textoEditable = '';
             el campo titulo solo es para contenidos 
            if(this.campoRequeridoEsValido(Titulo)) {
                const PARTES_TITULO = Titulo.split(' ');
                 primer valor del arreglo, ejemplo: 2020/NOTICIAS{0} texto del titulo{1}
                this.formulario.textoInicialTitulosComunicados = PARTES_TITULO[0];
                for(let i=1;i<PARTES_TITULO.length;i++) {
                    textoEditable += (PARTES_TITULO[i] + ' ');
                }
                textoEditable = (this.campoRequeridoEsValido(textoEditable)) ? textoEditable.trim() : textoEditable;
            } */
            this.formulario.titulo = Titulo;
        },
        llenarCamposDisposicionEspecial: async function() {
            const { EsDisposicionEspecial, Submenu } = this.contenidos.contenidoSeleccionado;
            this.formulario.esDisposicionEspecial = EsDisposicionEspecial
            if(this.campoRequeridoEsValido(Submenu) && EsDisposicionEspecial) {
                // el subidor solo permitia en submenus de covid
                const SUBMENU_COVID_ID = 136;
                const { Titulo, SubmenuAlQuePertenezco } = Submenu;
                if(this.campoRequeridoEsValido(SubmenuAlQuePertenezco)) {
                    this.formulario.catalogoSubmenu.valorDefinido = SUBMENU_COVID_ID;
                    this.formulario.catalogoSubmenu.contRender ++;
                }
                this.formulario.tituloSubMenu = Titulo;
            }
        },
        llenarFechasContenido: async function() {
            const { FechaDePublicacion, FechaDePublicacionFinal } = this.contenidos.contenidoSeleccionado;
            console.log('FechaDePublicacion::',FechaDePublicacion)
            const ES_COMUNICADO = this.paginaRequiereComunicado(this.contenidos.filtrosBusqueda.paginaWebId);
            this.formulario.fechaPublicacion.inicio.fecha = moment(FechaDePublicacion).toDate();
            if(ES_COMUNICADO) {
                this.formulario.fechaPublicacion.inicio.fin = moment(FechaDePublicacionFinal).toDate();
                await Promise.resolve(this.inicializarSwitchComunicados());
            }
        },
        inicializarSwitchComunicados: async function() {
            const { EsPin, EsUrgente } = this.contenidos.contenidoSeleccionado;
            this.formulario.esPin = EsPin;
            this.formulario.esUrgente = EsUrgente;
        },
        llenarVinculosContenido: async function() { debugger
            const { Vinculo, TextoDelVinculo } = this.contenidos.contenidoSeleccionado;
            console.log('Prueba::1::',this.contenidos.contenidoSeleccionado)
            if(this.formulario.archivos.lista.length == 1) {
                const { RutaDelArchivo, NombreBase } = this.formulario.archivos.lista[0];
                this.formulario.vinculo.texto = TextoDelVinculo;
                this.formulario.archivos.vinculo = TextoDelVinculo;
                this.formulario.vinculo.url = Vinculo;
                if(NombreBase == 'vinculoExternoArchivo') {
                    this.formulario.archivos.esVinculo = true;
                    this.formulario.archivos.url = RutaDelArchivo;
                    this.formulario.archivos.esVinculoExterno = true;
                }
                // se actualiza swith es vinculo a otra pagina
                if(this.campoRequeridoEsValido(Vinculo)) {
                    this.formulario.vinculo.vinculoRadio = true;
                    this.formulario.archivos.descargaRadio = false;
                }
                const ARCHIVO_DE_CONTENIDO = this.formulario.archivos.lista[0];
                this.formulario.archivos.vinculo = ARCHIVO_DE_CONTENIDO.TextoDelVinculo;
            }
            else if(this.formulario.archivos.lista.length < 1 && this.campoRequeridoEsValido(Vinculo)) {
                this.formulario.vinculo.vinculoRadio = true;
                this.formulario.archivos.descargaRadio = false;
                this.formulario.archivos.vinculo = TextoDelVinculo; // modificacion realizada 13/05/2021 - estatus = pruebas
                this.formulario.vinculo.texto = TextoDelVinculo;
                this.formulario.vinculo.url = Vinculo;
            }
            this.esVinculoPredeterminado();
        },
        llenarDescripcionContenido: async function() { 
            // variables para los casos president@ o magristrad@
            const PAGINA_PRESIDENTES_ID = 12;
            const PAGINA_MAGISTRADOS_TRIBUNAL_ID = 4;
            const PAGINA_MAGISTRADOS_SALA_ID = 6;
            const SECCION_DESIGNADO_POR_ID = 3;
            const PAGINA_CONSEJEROS_ID = 2;
            const ES_SECCION_DESIGANDO_POR = (this.contenidos.filtrosBusqueda.secccionId == SECCION_DESIGNADO_POR_ID);
            // descripcion de contenido
            const { TextoDelContenido } = this.contenidos.contenidoSeleccionado;
            switch(true) {
                // pagina web tipo presidentes
                case this.contenidos.filtrosBusqueda.paginaWebId == PAGINA_PRESIDENTES_ID:
                    const INFORMACION_PRESIDENTE = TextoDelContenido.split("¶");
                    this.formulario.nombrePresidente = INFORMACION_PRESIDENTE[0];
                    this.formulario.rangoPresidente = INFORMACION_PRESIDENTE[1];
                    break;
                // paginas web Magistrados del supremo tribunal de justicia y Magistrados de sala administrativa 
                case (this.contenidos.filtrosBusqueda.paginaWebId == PAGINA_MAGISTRADOS_TRIBUNAL_ID || 
                      this.contenidos.filtrosBusqueda.paginaWebId == PAGINA_MAGISTRADOS_SALA_ID):
                    const INFORMACION_MAGISTRADO = TextoDelContenido.split("\n");
                    console.log('INFORMACION_MAGISTRADO::',INFORMACION_MAGISTRADO);
                    this.formulario.nombrePresidente = INFORMACION_MAGISTRADO[0];
                    let textosSinTitulos = TextoDelContenido;
                    textosSinTitulos = textosSinTitulos.replace(INFORMACION_MAGISTRADO[0], '');
                    textosSinTitulos = textosSinTitulos.replace(INFORMACION_MAGISTRADO[1], '');
                    textosSinTitulos = textosSinTitulos.replace(INFORMACION_MAGISTRADO[2], '');
                    this.formulario.descripcion = textosSinTitulos.trim();
                    this.formulario.numerofilasDescripcion = 10;
                    break;
                // en este caso se trata de una seccion consejero
                case (ES_SECCION_DESIGANDO_POR && this.contenidos.filtrosBusqueda.paginaWebId == PAGINA_CONSEJEROS_ID):
                    const INFORMACION_DESIGNADO = TextoDelContenido.split("¶");
                    this.formulario.nombrePresidente = INFORMACION_DESIGNADO[0];
                    const INFORMACION_PODER = INFORMACION_DESIGNADO[1].split(' ');
                    const ES_SUPLENTE = (INFORMACION_PODER.length > 1 && INFORMACION_PODER[INFORMACION_PODER.length -1].includes('(Suplente)'));
                    // se obtiene la informacion referente al poder que designa 
                    if(ES_SUPLENTE)
                        INFORMACION_PODER.pop(); // se quita la ultima palabra (la que indica si es suplente)
                    const NOMBRE_PODER = INFORMACION_PODER.join(' ');
                    const PODER_SELECCIONADO = this.formulario.catalogoPoderes.PODERES.find(p => p.nombre == NOMBRE_PODER);
                    if(this.campoRequeridoEsValido(PODER_SELECCIONADO)) {
                        // se inicializa el catalogo con poder seleccionado
                        this.formulario.catalogoPoderes.valorDefinido = PODER_SELECCIONADO.valor;
                        this.formulario.catalogoPoderes.contRender ++;
                        this.formulario.catalogoPoderes.poderQueDesigna = PODER_SELECCIONADO.nombre;
                        // se incializa valor de switch es suplente
                        this.formulario.esSuplente = ES_SUPLENTE;
                    }
                    break;
                default:
                    this.formulario.descripcion = TextoDelContenido;
                    break;
            }
        },
        llenarListaDeArchivosFormulario: async function() {
            this.formulario.archivos.lista = this.contenidos.contenidoSeleccionado.ArchivosDeContenidoDeLaPaginaWeb.map(ac => {
                //let archivoObj = Object.create(ac);
                let archivoObj = ac;
                let esArchivoConVinculo = (this.campoRequeridoEsValido(ac) && !ac.RutaDelArchivo.includes('themisfs\files\sicpo'));
                archivoObj.tipoDeVisualizacion = {
                    esVinculo: esArchivoConVinculo,
                    html: (esArchivoConVinculo) ? `<div>
                                                     <button id="descargar-archivo-SICPO" type="button" class="btn btn-sm btn-xs btn btn-success texto-ajustable align-middle align-center"><i class="fas fa-file-download"></i>&nbsp;Descargar</button>
                                                   </div>`
                                                :  `<a href="${ ac.RutaDelArchivo }" target="_blank">${ ac.RutaDelArchivo }</a>`
                };
                archivoObj.Estatus = `<label id="switch-activo-inactivo-archivo-VEDC-${ ac.ArchivoDeContenidoDeLaPaginaWebId }" class="switch-contenido-activo-VEDC">
                                        <input id="check-archivo-activo-VEDC-${ ac.ArchivoDeContenidoDeLaPaginaWebId }" type="checkbox">
                                        <div id="slider-activo-inactivo-archivo-VEDC-${ ac.ArchivoDeContenidoDeLaPaginaWebId }" class="slider-contenido-activo-VEDC"></div>
                                      </label>`;
                return archivoObj;
            });
            // se asigna el valor de archivo inicial para las validaciones de campos requeridos
            if(!this.inputRequerido.listaDeArchivos.requerido) {
                this.formulario.archivos.archivo = this.formulario.archivos.lista[0];
                // se obtiene valor si archivo se meustra en visor
                if(this.campoRequeridoEsValido(this.formulario.archivos.lista[0])) {
                    this.formulario.archivos.mostrarEnVisor = (this.campoRequeridoEsValido(this.formulario.archivos.lista[0].MostrarEnVisor))
                        ? this.formulario.archivos.lista[0].MostrarEnVisor : false;
                }
            }
        },
        evtDescargarArchivo: function(rutaArchivo) { 
            var a = document.createElement("a");
            document.body.appendChild(a);
            a.target = (this.formulario.archivos.esVinculoExterno) ? "_blank" : '';
            a.href = (this.formulario.archivos.esVinculoExterno) ? rutaArchivo : `${api.conexion}${api.Comun.funcion.DescargarArchivo}?rutaDelArchivo=${rutaArchivo}`
            a.click();
        },
        evtDescargarArchivoEnMemoria: function(row) {
            const ARCHIVO_FILE = this.formulario.archivos.identificadoresDeArchivos.find(ia => ia.llave == row.RutaDelArchivo);
            if(this.campoRequeridoEsValido(ARCHIVO_FILE)) {
                const CREADOR_URL = window.URL || window.webkitURL;
                const URL_ARCHIVO_DESCARGA = CREADOR_URL.createObjectURL(new Blob([ARCHIVO_FILE.archivo], { type: ARCHIVO_FILE.archivo.type }));
                var a = document.createElement("a");
                a.download = ARCHIVO_FILE.archivo.name;
                a.href = URL_ARCHIVO_DESCARGA;
                document.body.appendChild(a);
                a.click();
            }
        },
        limpiarModalEstatus: function() {
            this.esActivacionMultipleContenidos = false;
            this.$nextTick(() => {
                $("#switch-cambio-estatus-modal").prop('checked',false);
            });
        },
        limpiarInputsDisposicionesEspeciales: function() {
            this.formulario.esDisposicionEspecial = false;
            this.formulario.catalogoSubmenu.valorDefinido = -1;
            this.formulario.catalogoSubmenu.seleccion = null;
            this.formulario.catalogoSubmenu.contRender ++;
            this.formulario.tituloSubMenu = null;
        },
        limpiarInputsFechas: function(fechaALimpiar) {
            let datePicker = null;
            switch(fechaALimpiar) {
                case this.CASOS_LIMPIEZA_FECHAS.INICIO:
                    datePicker = this.formulario.fechaPublicacion.inicio;
                    break;
                case this.CASOS_LIMPIEZA_FECHAS.FIN:
                    datePicker = this.formulario.fechaPublicacion.fin;
                    break;
                case this.CASOS_LIMPIEZA_FECHAS.TODAS:
                    // fecha de inicio
                    datePicker = this.formulario.fechaPublicacion.inicio;
                    datePicker.fecha = new Date();
                    datePicker.fechaSeleccionada = 0;
                    datePicker.fechaDefault = new Date();
                    datePicker.contRender ++;
                    // fecha fin
                    datePicker = this.formulario.fechaPublicacion.fin;
                    datePicker.fecha = new Date();
                    datePicker.fechaSeleccionada = 0;
                    datePicker.fechaDefault = new Date();
                    datePicker.contRender ++;
                    break;
                default:
                    return;
            }
            datePicker.fecha = new Date();
            datePicker.fechaSeleccionada = 0;
            datePicker.fechaDefault = new Date();
            datePicker.contRender ++;
        },
        limpiarInputsVinculo: function() {
            this.formulario.vinculo.texto = null;
            this.formulario.vinculo.url = null;
            this.formulario.vinculo.vinculoRadio = false;
            this.formulario.archivos.esVinculoExterno = false;
        },
        limpiarInputsArchivos: function() {
            $("#archivo-descarga-contenido").val('');
            this.formulario.archivos.archivo = null;
            this.formulario.archivos.lista = [];
            this.formulario.archivos.archivoSeleccionado = null;
            this.formulario.archivos.archivosSeleccionados = [];
            this.formulario.archivos.identificadoresDeArchivos = [];
            this.formulario.archivos.descargaRadio = true;
            this.formulario.archivos.esVinculo = false;
            this.formulario.archivos.url = null;
            this.formulario.archivos.contador = 1;
            this.formulario.archivos.utilizoSubidor = false;
            this.formulario.archivos.activacionMultiple = true;
        },
        limpiarInputsImagenes: function(limpiarImagenesObligaciones) {
            $("#imagen_contenido").val('');
            this.formulario.imagenDeContenido.nombre = null;
            this.formulario.imagenDeContenido.archivo = null;
            this.formulario.imagenDeContenido.utilizoSubidor = false;
            if(limpiarImagenesObligaciones) {
                this.formulario.imagenesObligaciones.lista = [];
                this.formulario.imagenesObligaciones.contRender ++;
            }
        },
        limpiarInputsTexto: function() {
            this.formulario.titulo = null;
            this.formulario.textoInicialTitulosComunicados = null;
            this.formulario.nombrePresidente = null;
            this.formulario.rangoPresidente = null;
            this.formulario.descripcion = null;
            this.formulario.numerofilasDescripcion = 3;
        },
        limpiarContenidosSeleccionados: function() {
            this.contenidos.contenidosSeleccionados = [];
        },
        limpiarInputsConsejeros: function() {
            this.formulario.catalogoPoderes.valorDefinido = -1;
            this.formulario.catalogoPoderes.poderQueDesigna = null;
        },
        limpiarFormulario: function() {
            this.formulario.mostrarSeccionDeArchivos = false; // propiedad para visualizar seccion de archivos
            this.formulario.camposRequeridosFormulario = null; 
            this.formulario.esPin = false; // propiedad para indicar que comunicado tendra pin en el portal
            this.formulario.mostrarErroresInput = false;
            this.formulario.mensajeError = null;
            this.formulario.esSuplente = false; // propiedad utilizada en desigando por
            this.formulario.esTextoDeVinculoPredeterminado = false;
            this.limpiarInputsTexto();
            this.limpiarInputsConsejeros();
            const LIMPIAR_IMAGENES_OBLIGACIONES = false;
            this.limpiarInputsImagenes(LIMPIAR_IMAGENES_OBLIGACIONES);
            this.limpiarInputsArchivos();
            this.limpiarInputsVinculo();
            this.formulario.esUrgente = false; // propiedad para el switch del pin en comunicados
            this.limpiarInputsFechas(this.CASOS_LIMPIEZA_FECHAS.TODAS);
            this.limpiarInputsDisposicionesEspeciales();
            this.limpiarContenidosSeleccionados();
            this.formulario.imagenDeContenido.conVisualizador = false;
            this.ordenarContenidos.mostrar = false;
           /*  if(this.campoRequeridoEsValido(mensaje));
                comun.mensajeDeAlerta(mensaje); */
        },
        evtCambiosRealizadosEnArchivos: async function() {
            this.formulario.mostrarSeccionDeArchivos = false;
            this.formulario.mostrarErroresInput = false;
            this.formulario.mensajeError = null;
            this.formulario.archivos.esVinculo = false;
            //await Promise.resolve(this.llenarImagenPredeterminadaObligacion());
            if(this.inputRequerido.imagenesObligaciones.requerido)
                await Promise.resolve(this.persistirSeleccionImagenObligaciones());
        },
        persistirSeleccionImagenObligaciones: async function() {
            if(this.campoRequeridoEsValido(this.formulario.imagenesObligaciones.imagenSeleccionada)) {
                const { imagenSeleccionada } = this.formulario.imagenesObligaciones;
                console.log('imagenSeleccionada::',imagenSeleccionada);
                this.$nextTick(async () => {
                    // Se posiciona scroll en la posicion de la imagen seleccionada
                    const POSICION_IMAGEN_ELEMENTO = $("#" + imagenSeleccionada.llave + 'img').offset().top;
                    // Veriifacr si el valor 400 es para todo los tipos de altura de las pantallas
                    $("#" + this.formulario.imagenesObligaciones.DIV_PADRE_ID).scrollTop(POSICION_IMAGEN_ELEMENTO - 400);
                    $("#" + imagenSeleccionada.llave).trigger("click");
                    // cuando actualiza estos valores, la tabla se actualiza y pierde los valores de los switch
                    await Promise.resolve(this.persistirSwitchAContenidosActivos());
                });
            }
        },
        llenarTablaArchivos: function() {
            this.$nextTick(() => {
                $("#tabla-archivos-contenido").bootstrapTable({  data: this.formulario.archivos.lista });      
                $("#tabla-archivos-contenido").bootstrapTable('load',  this.formulario.archivos.lista);  
                $("#tabla-archivos-contenido").off("check.bs.table uncheck.bs.table check-all.bs.table uncheck-all.bs.table page-change.bs.table sort.bs.table");
                $('#tabla-archivos-contenido').on('check.bs.table',(e, row) => {
                    this.evtSeleccionoArchivo(e, row);
                });
                $('#tabla-archivos-contenido').on('uncheck.bs.table',(e, row) => {
                    const TIPO_CHECK = 'UNO';
                    this.evtRemoverArchivosEnListaSeleccionados(e, row,TIPO_CHECK);
                });
                $('#tabla-archivos-contenido').on('check-all.bs.table',(e, rows) => {
                    this.evtSeleccionoTodosLosArchivos(e, rows);
                });
                $('#tabla-archivos-contenido').on('uncheck-all.bs.table',(e, rowsAfter, rowsBefore) => {
                    const TIPO_CHECK = 'MUCHOS';
                    this.evtRemoverArchivosEnListaSeleccionados(e, rowsBefore,TIPO_CHECK);
                });
                $('#tabla-archivos-contenido').on('page-change.bs.table', (size, number) => {
                    this.$nextTick(async () => {
                        await Promise.resolve(this.persistirSwitchArchivosActivos());
                    });
                });
                $('#tabla-archivos-contenido').on('sort.bs.table', (name, order) => {
                    this.$nextTick(async () => {
                        await Promise.resolve(this.persistirSwitchArchivosActivos());
                    });
                });
                // bs table no reconoce clases css del componenete, una vez que se cargan los datos se asigna las clases de de manera global 
                $("td[id^=switch-activo-inactivo-archivo-VEDC]").addClass('switch-contenido-activo-VEDC');
                $("td[id^=slider-activo-inactivo-archivo-VEDC]").addClass('slider-contenido-activo-VEDC');
            });
        },
        evtMostrarTablaArchivos: async function() {
            this.formulario.mostrarSeccionDeArchivos = true;
            this.formulario.archivos.archivo = null;
            this.formulario.archivos.vinculo = null;
            $("#archivo-descarga-contenido").val('');
            this.llenarTablaArchivos();
            this.$nextTick(async () => {
                await Promise.resolve(this.persistirSwitchArchivosActivos());
            });
        },
        obtenerImagenesObligaciones: async function() {
            try {
                const SERVIDOR = api.conexion;
                const METODO_API_OBTENER = api.SICPO.catalogos.C021ImagenesPredeterminadas;
                let urlApi = SERVIDOR + METODO_API_OBTENER;
                let peticionAPI = {
                    ImagenPredeterminadaId: null,
                    SeccionDeLaPaginaWebId: this.contenidos.filtrosBusqueda.secccionId,
                    ConSeccionesDeLaPaginaWeb: false,
                    ConInactivos: false,
                    ConRutasParaAccesoDesdeFront:true,
                    esPrueba: false
                }
                let peticionArchivos = false;
                let headerPeticion = comun.CrearElHeaderDeAutorizacion(this.$store.state.Login_AutorizacionOriginal, peticionArchivos,false);
                comun.SeEstaCargandoInformacion(true);
                const PETICION_IMAGENES_OBLIGACIONES = await axios.post(urlApi, peticionAPI, headerPeticion);
                const DATOS_PETICION = await PETICION_IMAGENES_OBLIGACIONES.data;
                let { SiHayError, Error, ImagenesPredeterminadas } = DATOS_PETICION;
                if (SiHayError) {
                    let mensajeError = Error.Mensaje;
                    comun.SeEstaCargandoInformacion(false);
                    console.log(mensajeError);
                    comun.mensajeDeAlerta(mensajeError, null, null);
                } 
                else {
                    await Promise.resolve(this.crearObjetoDeImagenesObligaciones(ImagenesPredeterminadas));
                    console.log('LISTA::PRED::',this.formulario.imagenesObligaciones.lista)
                    comun.SeEstaCargandoInformacion(false);
                }
            }
            catch(excepcion) {
                comun.SeEstaCargandoInformacion(false);
                console.log(excepcion);
                comun.mensajeDeAlerta(enumeraciones.error.E500, null, null);
            }
        },
        crearObjetoDeImagenesObligaciones: async function(listaImagenes) {
            if(this.campoRequeridoEsValido(listaImagenes))
                this.formulario.imagenesObligaciones.lista = listaImagenes.map(i => {
                    let objImg = {
                        llave: i.ImagenPredeterminadaId,
                        imagen: i.RutaDeLaImagen
                    }
                    return objImg;
                });
            else
                this.formulario.imagenesObligaciones.lista = [];
        },
        evtCambioTipoSubmenu: function(evento,menuObjSeleccionado) {
            console.log('evtCambioTipoSubmenu::', menuObjSeleccionado);
            this.formulario.catalogoSubmenu.valorDefinido = parseInt(evento.target.value);
            this.formulario.catalogoSubmenu.seleccion = menuObjSeleccionado;
        },
        evtSeleccionDeFechaDtPk: function() {
            this.$nextTick(() => {
                let FECHA_INICIO = moment(this.formulario.fechaPublicacion.inicio.fecha).format(this.contenidos.fechas.FORMATO);
                let FECHA_FIN =  moment(this.formulario.fechaPublicacion.fin.fecha).format(this.contenidos.fechas.FORMATO);
                if(FECHA_INICIO > FECHA_FIN) {
                    this.formulario.fechaPublicacion.fin.fecha = this.formulario.fechaPublicacion.inicio.fecha;
                    this.formulario.fechaPublicacion.inicio.fechaDefault = this.formulario.fechaPublicacion.fin.fecha;
                }
            });
        },
        evtSubidorArchivoContenido: function(evento, agregarListado) {
            try{
                if(evento.target.files.length > 0) {
                    const NOMBRE_DE_ARCHIVO = evento.target.files[0].name;
                    if(this.verificaQueSeaElDocumentoCorrecto(NOMBRE_DE_ARCHIVO,'DESCARGA')) {
                        const ARCHIVO = evento.target.files[0];
                        if(agregarListado)
                            this.crearObjArchivoDeContenido(NOMBRE_DE_ARCHIVO, ARCHIVO, agregarListado);
                        else 
                            this.formulario.archivos.archivo = ARCHIVO;
                            // agregar en evento toggle es vinculo en caso cunado es uno archivo removerlo del listado
                        this.formulario.archivos.utilizoSubidor = true;
                    }
                    else {
                        $("#archivo-descarga-contenido").val('');
                        if(!this.inputRequerido.listaDeArchivos.requerido) {
                            this.formulario.archivos.utilizoSubidor = false;
                            this.formulario.archivos.archivo = this.formulario.archivos.lista[0];
                            this.formulario.archivos.identificadoresDeArchivos = [];
                        }
                        //comun.mensajeDeAlerta('Para las imagenes solo se permiten extensiones JPEG,JPG y PNG,<br>Seleccione otra imagen con una de las siguientes extensiones JPEG,JPG o PNG');
                    }
                }
                else {
                    // si no se selecciona una rchivo nuevo valido se muestra el archivo original del contenido.
                    if(!this.inputRequerido.listaDeArchivos.requerido) {
                        this.formulario.archivos.utilizoSubidor = false;
                        this.formulario.archivos.archivo = this.formulario.archivos.lista[0];
                        this.formulario.archivos.identificadoresDeArchivos = [];
                    }
                }
            }
            catch(error) {
                comun.mensajeDeAlerta(error);
            }
        },
        crearObjArchivoDeContenido: function(nombreArchivo, archivo, agregarListado) { 
            this.formulario.archivos.contador ++;
            let ArchivoDeContenidoObj = {
                Activo: true,
                ArchivoDeContenidoDeLaPaginaWebId: -1,
                ContenidoDeLaPaginaWeb: { ContenidoDeLaPaginaWebId: this.contenidos.contenidoSeleccionado.ContenidoDeLaPaginaWebId },
                FechaDeRegistro: moment(),
                NombreBase: nombreArchivo,
                NombreEnServidor: nombreArchivo,
                RutaDelArchivo: (this.formulario.archivos.esVinculo) ? this.formulario.archivos.url :`${ this.formulario.archivos.ES_NUEVO + this.formulario.archivos.contador }`,
                TextoDelVinculo: (!this.formulario.vinculo.vinculoRadio) ? this.formulario.archivos.vinculo : this.formulario.vinculo.texto,
                TipoRolDeArchivoEnContenido: null,
                // propiedades para acciones en tabla de archivos
                tipoDeVisualizacion: {
                    esVinculo: this.formulario.archivos.esVinculo,
                    html: (!this.formulario.archivos.esVinculo) ? `<div>
                                                                    <button id="descargar-archivo-SICPO" type="button" class="btn btn-sm btn-xs btn btn-success texto-ajustable align-middle align-center"><i class="fas fa-file-download"></i>&nbsp;Descargar</button>
                                                                  </div>`
                                                                : `<a href="https://${ this.formulario.archivos.url }" target="_blank">${ this.formulario.archivos.url }</a>`
                },
                Estatus: `<button id="eliminar-archivo-pw-SICPO" type="button" class="btn btn-sm btn-xs btn-danger texto-ajustable align-middle align-center"><i class="fas fa-trash" ></i></button>`
            }
            if(agregarListado) {
                // si el archivo no es File y es url no crea una llave identificadora para el archivo
                const NUMERO_DE_ARCHIVOS = $("#tabla-archivos-contenido >tbody >tr").length;
                const INDEX_CONSECUTIVO = NUMERO_DE_ARCHIVOS + 1;
                $('#tabla-archivos-contenido').bootstrapTable('insertRow',{
                    index: INDEX_CONSECUTIVO,
                    row: ArchivoDeContenidoObj
                });
                // si es un archivo con File agrega su referencia y el objeto File para la construccion de la peticion
                if(!this.formulario.archivos.esVinculo) {
                    const ARCHIVO_CON_IDENTIFICADOR = { archivo: archivo, llave: ArchivoDeContenidoObj.RutaDelArchivo };
                    this.formulario.archivos.identificadoresDeArchivos.push(ARCHIVO_CON_IDENTIFICADOR);
                }
                // limpia las variables relacionadas a la seccion de archivos en el formulario
                this.formulario.archivos.archivo = null;
                this.formulario.archivos.vinculo = null;
                this.formulario.archivos.url = null;
                $("#archivo-descarga-contenido").val('');
                // persiste la informacion de los switch de activacion
                this.$nextTick(async () => {
                    await Promise.resolve(this.persistirSwitchArchivosActivos());
                });
            }
            return ArchivoDeContenidoObj;
        },
        evtAgregarArchivoListaDeArchivosContenido: function() { 
            const MOSTRAR_ESTATUS_DE_VALIDACION = true;
            if(this.validacionesFormulario(this.formulario.VALIDACIONES.agregarArchivoEnListado, MOSTRAR_ESTATUS_DE_VALIDACION)) {
                const NOMBRE_ARCHIVO = (this.formulario.archivos.esVinculo) ? this.formulario.archivos.vinculo : this.formulario.archivos.archivo.name;
                const AGREGAR_EN_LISTA_ARCHIVOS = true;
                this.crearObjArchivoDeContenido(NOMBRE_ARCHIVO, this.formulario.archivos.archivo, AGREGAR_EN_LISTA_ARCHIVOS);
            }
            else {
                this.formulario.mostrarErroresInput = true;
            }
        },
        evtSubidorImagen: function(evento) {
            try{
                if(evento.target.files.length > 0) {
                    const NOMBRE_DE_ARCHIVO = evento.target.files[0].name;
                    if(this.verificaQueSeaElDocumentoCorrecto(NOMBRE_DE_ARCHIVO,'IMAGEN')) {
                        const ARCHIVO = evento.target.files[0];
                        this.formulario.imagenDeContenido.ruta = this.formulario.imagenDeContenido.IDENTIFICADOR;
                        this.formulario.imagenDeContenido.archivo = ARCHIVO;
                        this.formulario.imagenDeContenido.utilizoSubidor = true;
                    }
                    else {
                        this.formulario.imagenDeContenido.utilizoSubidor = false;
                        this.formulario.imagenDeContenido.archivo = this.formulario.imagenDeContenido.ruta;
                        /* this.formulario.imagenDeContenido.ruta = null;
                        this.formulario.imagenDeContenido.archivo = null; */
                        $("#imagen_contenido").val('');
                        //comun.mensajeDeAlerta('Para las imagenes solo se permiten extensiones JPEG,JPG y PNG,<br>Seleccione otra imagen con una de las siguientes extensiones JPEG,JPG o PNG');
                    }
                }
                else {
                    this.formulario.imagenDeContenido.utilizoSubidor = false;
                    this.formulario.imagenDeContenido.archivo = this.formulario.imagenDeContenido.ruta;
                    /* this.formulario.imagenDeContenido.ruta = null;
                    this.formulario.imagenDeContenido.archivo = null; */
                    $("#imagen_contenido").val('');
                }
            }
            catch(error) {
                comun.mensajeDeAlerta(error);
            }
        },
        verificaQueSeaElDocumentoCorrecto: function(nombreArchivo,tipoDocumento) {
            const NOMBRE_CORTADO = nombreArchivo.split(".");
            let siEsUnDocumentoValido = false;
            switch(tipoDocumento) {
                case 'DESCARGA':
                    const EXTENSION_ARCHIVO = NOMBRE_CORTADO[NOMBRE_CORTADO.length - 1].toUpperCase();
                    if(EXTENSION_ARCHIVO === 'PDF' || EXTENSION_ARCHIVO === 'XLSX' || EXTENSION_ARCHIVO === 'XLSB' || EXTENSION_ARCHIVO === 'ZIP')
                        siEsUnDocumentoValido = true;

                    break;
                case 'IMAGEN':
                    const EXTENSION_IMAGEN = NOMBRE_CORTADO[NOMBRE_CORTADO.length - 1].toUpperCase();
                    if(EXTENSION_IMAGEN === 'JPEG' || EXTENSION_IMAGEN === 'JPG' || EXTENSION_IMAGEN === 'PNG')
                        siEsUnDocumentoValido = true;
                        
                    break;
                default:
            }
            return siEsUnDocumentoValido;
        },
        evtSeleccionImagenObligaciones: async function(evento,imagenEstaSeleccionada) {
            //console.log('IO::', evento.target.getAttribute('id'));
            const LLAVE_IMAGEN_SELECCIONADA = evento.target.getAttribute('id');
            if(imagenEstaSeleccionada)
                this.formulario.imagenesObligaciones.imagenSeleccionada = this.formulario.imagenesObligaciones.lista.find(i => i.llave == LLAVE_IMAGEN_SELECCIONADA);
            else
                this.formulario.imagenesObligaciones.imagenSeleccionada = null;
            this.$nextTick(async () => {
                await Promise.resolve(this.persistirSwitchAContenidosActivos());
            });
            //console.log('this.formulario.imagenesObligaciones.imagenSeleccionada::',this.formulario.imagenesObligaciones.imagenSeleccionada);
        },
        recargarImagenesPredeterminadas: function() {

        },
        cambioCatalogoPoderes: function(evento) { 
            this.formulario.catalogoPoderes.valorDefinido = parseInt(evento.target.value);
            this.formulario.catalogoPoderes.poderQueDesigna = evento.target.options[evento.target.selectedIndex].text;
        },
        identificarCamposParaFormulario: async function() { 
            let camposDeFormulario = ['textoDelContenido','textoDelVinculo','archivosDeContenido','vinculo','titulo','imagenDeContenido', 'opcionesComunicadoUrgente', 'fechaDePublicacion','listaDeArchivos','rangoPresidente','nombrePresidente','archivoConVinculo','disposicionEspecial','catalogoPoderes','imagenesObligaciones'];
            let camposNecesariosFormulario = {};
            camposNecesariosFormulario['tipoDeFormulario'] = this.paginaRequiereComunicado(this.contenidos.filtrosBusqueda.paginaWebId)? 'comunicado': 'comun';
            // valida si es formulario para contenidos por id de pagina o seccion
            const SECCION_DESIGNADO_POR = 3;
            const COMPARAR_CON_SECCION = (this.contenidos.filtrosBusqueda.esSubSeccion || this.contenidos.filtrosBusqueda.secccionId == SECCION_DESIGNADO_POR);
            const TIPO_CONTENIDO_ID = (COMPARAR_CON_SECCION) ? this.contenidos.filtrosBusqueda.secccionId : this.contenidos.filtrosBusqueda.paginaWebId;
            for(let i=0;i<camposDeFormulario.length; i++) {
                let llave = camposDeFormulario[i];
                let valoresDeCampo = await Promise.resolve(this.asignarPrioridadACamposDeFormulario(TIPO_CONTENIDO_ID, llave, COMPARAR_CON_SECCION));
                camposNecesariosFormulario[llave] = valoresDeCampo;
            }
            this.formulario.camposRequeridosFormulario = camposNecesariosFormulario;
        },
        evtBusquedaContenidos: async function(parametrosBusqueda) { 
            console.log('param::',parametrosBusqueda);
            this.ordenarContenidos.mostrar = false;
            this.contenidos.filtrosBusqueda = parametrosBusqueda;
            const ES_DESPUES_DE_ACTUALIZACION = false;
            const MENSAJE_DE_ACTUALIZACION = '';
            this.obtenerContenidos(parametrosBusqueda, ES_DESPUES_DE_ACTUALIZACION, MENSAJE_DE_ACTUALIZACION);
        },
        obtenerContenidos: function(parametros, esDespuesDeActualizacion, mensajeDeActualizacion) { 
            const SERVIDOR = api.conexion;
            const METODO_API_OBTENER = api.SICPO.sistema.paginaweb.ediciondecontenido.GetContenidosDePaginaWeb;
            let urlApi = SERVIDOR + METODO_API_OBTENER;
            let peticionArchivos = false;
            const ID_REQUIEREN_LISTA_ARCHIVOS = [83,84,85,86,87,88,89,90,95,96,97,98,99,100,101,102,117,118,119,122,123,126,127,130,131,132,135,137,139,141,145,66,67,68,69,70,71,72,73,74,75,76,77,78,167,168,169,170,171,172,173,174,168,170,172,174];
            let peticionAPI = {
                PaginaWebId: parametros.paginaWebId,
                SeccionDeLaPaginaWebId: parametros.secccionId,
                FechaInicial: parametros.fechaInicial,
                FechaFinal: parametros.fechaFinal,
                ConArchivosInactivos: (ID_REQUIEREN_LISTA_ARCHIVOS.some(seccion => seccion == parametros.secccionId)),
                esPrueba: false
            }
            let headerPeticion = comun.CrearElHeaderDeAutorizacion(this.$store.state.Login_AutorizacionOriginal, peticionArchivos,false);
            this.cargandoCedulas = true;
            if(!esDespuesDeActualizacion)
                comun.SeEstaCargandoInformacion(true);
            axios.post(urlApi, peticionAPI, headerPeticion)
                    .then(respuesta => {            
                        if (respuesta.data.SiHayError) {
                            let mensajeError = respuesta.data.Error.Mensaje;
                            console.log(mensajeError);
                            comun.mensajeDeAlerta(mensajeError, null, null);
                        } 
                        else {
                            const { contenidosDePaginaWeb } = respuesta.data;
                            if(contenidosDePaginaWeb != null && contenidosDePaginaWeb.length > 0) {
                                this.contenidos.listaDeContenidosBD = contenidosDePaginaWeb;
                                console.log('data::',this.contenidos.listaDeContenidosBD);
                                this.$nextTick(async () => {
                                    await Promise.resolve(this.llenarTablaResultados(contenidosDePaginaWeb));
                                    await Promise.resolve(this.persistirSwitchAContenidosActivos());
                                });
                                this.ordenarContenidos.KEY ++;
                            }
                        }
                        comun.SeEstaCargandoInformacion(false);
                        if(esDespuesDeActualizacion)
                            comun.mensajeDeAlerta(mensajeDeActualizacion, null, null);
                    })
                    .catch(excepcion => {
                        comun.SeEstaCargandoInformacion(false);
                        console.log(excepcion);
                        comun.mensajeDeAlerta(enumeraciones.error.E500, null, null);
                    }
            ); 
        },
        darFormatoObjetosDeContenido: async function(contenidos) {
            const ESTATUS_ACTIVO_ID = 2;
            this.contenidos.listaDeContenidos = contenidos.map(c => {
                let { ContenidoDeLaPaginaWebId, TextoDelContenido, FechaDeRegistro, FechaDePublicacion, EsDisposicionEspecial } = c;
                let contenidoConFormato = Object.create(c);
                contenidoConFormato.FechaDeRegistro = moment(FechaDeRegistro).format(this.contenidos.fechas.FORMATO);
                contenidoConFormato.FechaDePublicacion = moment(FechaDePublicacion).format(this.contenidos.fechas.FORMATO);
                /* contenidoConFormato.EsComunicado = (this.paginaRequiereComunicado(this.contenidos.filtrosBusqueda.paginaWebId)) ? 'Si' : 'No';
                contenidoConFormato.EsDisposicionEspecial = (EsDisposicionEspecial) ? 'Si' : 'No'; */
                this.contenidos.mostrarTextoDelVinculo = !this.campoRequeridoEsValido(TextoDelContenido);
                contenidoConFormato.textoDescriptivo = {
                    texto: this.acortarTextoEnCelda(c),
                    mostrarTextoCompleto: false
                };
                contenidoConFormato.EstaActivo = {
                    activo: (c.TipoEstatusDelContenido.TipoEstatusDelContenidoId == ESTATUS_ACTIVO_ID),
                    html: `<label id="switch-activo-inactivo-VEDC-${ ContenidoDeLaPaginaWebId }" class="switch-contenido-activo-VEDC">
                            <input id="check-contenido-activo-VEDC-${ ContenidoDeLaPaginaWebId }" type="checkbox">
                            <div id="slider-activo-inactivo-VEDC-${ ContenidoDeLaPaginaWebId }" class="slider-contenido-activo-VEDC"></div>
                           </label>`
                };
                contenidoConFormato.UltimaModificacion = this.obtenrDatosDeUltimaModificacion(contenidoConFormato);
                return contenidoConFormato;
            });
            //console.log('columna-texto-descriptivo-VEDC-pw::',this.contenidos.mostrarTextoDelVinculo);
        },
        obtenrDatosDeUltimaModificacion: function(contenido) { 
            let datosDeUltimaModificacion = '';
            const { UsuarioQueModifico, UsuarioQueRegistro, FechaDeModificacion, FechaDeRegistro } = contenido;
            if(this.campoRequeridoEsValido(UsuarioQueModifico) && this.campoRequeridoEsValido(FechaDeModificacion)) {
                let DATOS_NOMBRE = [UsuarioQueModifico.Nombre, UsuarioQueModifico.ApellidoPaterno, UsuarioQueModifico.ApellidoMaterno]
                const NOMBRE_COMPLETO = DATOS_NOMBRE.join(' ');
                datosDeUltimaModificacion += `<strong>${ NOMBRE_COMPLETO.trim() }</strong>`;
                datosDeUltimaModificacion += '<br>';
                datosDeUltimaModificacion += `[${ moment(FechaDeModificacion).format(this.contenidos.fechas.FORMATO) }]`;
            }
            else if(this.campoRequeridoEsValido(UsuarioQueRegistro) && this.campoRequeridoEsValido(FechaDeRegistro)){
                let DATOS_NOMBRE = [UsuarioQueRegistro.Nombre, UsuarioQueRegistro.ApellidoPaterno, UsuarioQueRegistro.ApellidoMaterno]
                const NOMBRE_COMPLETO = DATOS_NOMBRE.join(' ');
                datosDeUltimaModificacion += `<strong>${ NOMBRE_COMPLETO.trim() }</strong>`
                datosDeUltimaModificacion += '<br>';
                datosDeUltimaModificacion += `[${ moment(FechaDeRegistro).format(this.contenidos.fechas.FORMATO) }]`;
            }
            else {
                datosDeUltimaModificacion += `sin datos`;
            }
            return datosDeUltimaModificacion;
        },
        acortarTextoEnCelda: function(contenido) { 
            let texto = '-';
            let tieneTexto = false;
            const TEXTO_DE_CONTENIDO = (this.contenidos.mostrarTextoDelVinculo) ? contenido.TextoDelVinculo : contenido.TextoDelContenido;
            if(this.campoRequeridoEsValido(TEXTO_DE_CONTENIDO)) {
                // si el texto del contenido es muy largo lo corta, numMax caracteres = 13
                texto = (TEXTO_DE_CONTENIDO.length > 45) ? TEXTO_DE_CONTENIDO.substring(0,44) : TEXTO_DE_CONTENIDO; 
                tieneTexto = true;
            } 
            return (tieneTexto && TEXTO_DE_CONTENIDO.length > 45) ? `${ texto }&nbsp;&nbsp;&nbsp;<i id="${ contenido.ContenidoDeLaPaginaWebId }-i-ampliarContenido" style="cursor: pointer;" class="icono-ampliar-texto fas fa-caret-down"></i>` : texto;
        },
        mostrarTextoDeContenidoCompleto: function(contenido, indexColumna) { debugger
            let contenidoObj = this.contenidos.listaDeContenidos.find(c => c.ContenidoDeLaPaginaWebId == contenido.ContenidoDeLaPaginaWebId);
            if(this.campoRequeridoEsValido(contenidoObj)) {
                const CONTENIDO_OBJ_COMPLETO = this.contenidos.listaDeContenidosBD.find(c => c.ContenidoDeLaPaginaWebId == contenido.ContenidoDeLaPaginaWebId);
                if(this.campoRequeridoEsValido(CONTENIDO_OBJ_COMPLETO)) {
                    if(!contenidoObj.textoDescriptivo.mostrarTextoCompleto) {
                        contenidoObj.textoDescriptivo.texto = (this.contenidos.mostrarTextoDelVinculo) ? CONTENIDO_OBJ_COMPLETO.TextoDelVinculo + `&nbsp;&nbsp;&nbsp;<i id="${ contenido.ContenidoDeLaPaginaWebId }-i-ampliarContenido" style="cursor: pointer;" class="icono-ampliar-texto fas fa-caret-up"></i>`
                        : CONTENIDO_OBJ_COMPLETO.TextoDelContenido + `&nbsp;&nbsp;&nbsp;<i id="${ contenido.ContenidoDeLaPaginaWebId }-i-ampliarContenido" style="cursor: pointer;" class="icono-ampliar-texto fas fa-caret-up"></i>`;
                        contenidoObj.textoDescriptivo.mostrarTextoCompleto = true;
                    }
                    else {
                        contenidoObj.textoDescriptivo.texto = this.acortarTextoEnCelda(CONTENIDO_OBJ_COMPLETO);
                        contenidoObj.textoDescriptivo.mostrarTextoCompleto = false;
                    }
                   /*  $("#tabla-contenidos").bootstrapTable('updateRow', {
                        index: indexColumna,
                        row: contenidoObj
                    }); */
                    /* MEJOR ACTUALIZAR POR ID PARA NO DUPLICAR REGISTROS CUANDO SE UTILIZA EL DATA SEARCH */
                    $("#tabla-contenidos").bootstrapTable('updateByUniqueId', {
                        id: contenido.ContenidoDeLaPaginaWebId,
                        row: contenidoObj
                    });
                    // al hacer render de la tabla llamar persistencia de valores en switch de activacion
                    this.$nextTick(async () => {
                        await Promise.resolve(this.persistirSwitchAContenidosActivos());
                    });
                }
            }
        },
        evtCambiarEstatusDeArchivo: async function(evento,archivo) {
            const { ArchivoDeContenidoDeLaPaginaWebId } = archivo;
            const ES_ESTATUS_ACTIVO = $('#check-archivo-activo-VEDC-' + ArchivoDeContenidoDeLaPaginaWebId).is(":checked");
            let archivoObj = this.formulario.archivos.lista.find(a => a.ArchivoDeContenidoDeLaPaginaWebId == ArchivoDeContenidoDeLaPaginaWebId);
            archivoObj.Activo = ES_ESTATUS_ACTIVO;
            this.$nextTick(async () => {
                await Promise.resolve(this.persistirSwitchArchivosActivos());
            });
        },
        persistirSwitchArchivosActivos: async function() {
            if(this.formulario.archivos.lista.length > 0) {
                this.formulario.archivos.lista.forEach(a => {
                    const ID_SWITCH_ACTIVO_ARCHIVO = `check-archivo-activo-VEDC-${ a.ArchivoDeContenidoDeLaPaginaWebId }`;
                    $("#" + ID_SWITCH_ACTIVO_ARCHIVO).prop('checked',  a.Activo);
                });
            }
        },
        evtMostrarFormulario: async function(contenido) {
            this.contenidos.contenidoSeleccionado = this.contenidos.listaDeContenidosBD.find(cbd => cbd.ContenidoDeLaPaginaWebId == contenido.ContenidoDeLaPaginaWebId);
            await Promise.resolve(this.identificarCamposParaFormulario());
            await Promise.resolve(this.llenarDatosEnFormulario());
            console.log('camposRequerdios::',this.formulario.camposRequeridosFormulario);
            $("#formulario-contenido").modal('show');
        },
        evtEliminarContenido: function(contenido) {
            this.contenidos.contenidoSeleccionado = this.contenidos.listaDeContenidosBD.find(cbd => cbd.ContenidoDeLaPaginaWebId == contenido.ContenidoDeLaPaginaWebId);
        },
        evtSeleccionoTodos: function(e, rows) {
            console.log('rows::',rows);
            this.contenidos.contenidosSeleccionados = rows.map(csel => {
                let contenidoObj = {};
                contenidoObj.ContenidoDeLaPaginaWebId = csel.ContenidoDeLaPaginaWebId;
                contenidoObj.TipoEstatusDelContenido = {
                    TipoEstatusDelContenidoId: 4
                };
                // estos valores no se actualizaran solo se llenan porque no son valores nullables de la entidad, es 
                // para prevenir error en la conversion de la peticion en controller
                contenidoObj.FechaDePublicacion = csel.FechaDePublicacion;
                contenidoObj.FechaDeRegistro = csel.FechaDeRegistro;
                contenidoObj.EsDisposicionEspecial = csel.EsDisposicionEspecial;
                contenidoObj.MostrarArchivos = csel.MostrarArchivos;
                return contenidoObj;
            })
            console.log('RGS::',this.contenidos.contenidosSeleccionados);
        },
        evtSeleccionoTodosLosArchivos: function(e, rows) {
            this.formulario.archivos.archivosSeleccionados = rows;
        },
        evtSeleccionoContenido: function(e, row) {
            if(!this.contenidos.contenidosSeleccionados.some(csel => csel.ContenidoDeLaPaginaWebId == row.ContenidoDeLaPaginaWebId)) {
                const CONTENIDO_ESTRUCTURA_BD = this.contenidos.listaDeContenidosBD.find(cbd => cbd.ContenidoDeLaPaginaWebId == row.ContenidoDeLaPaginaWebId);
                this.contenidos.contenidosSeleccionados.push(CONTENIDO_ESTRUCTURA_BD);
            }
        },
        evtSeleccionoArchivo: function(e, row) {
            const { archivos } = this.formulario;
            const ID_ARCHIVO = row.ArchivoDeContenidoDeLaPaginaWebId;
            if(!archivos.archivosSeleccionados.some(al => al.ArchivoDeContenidoDeLaPaginaWebId == ID_ARCHIVO)) {
                const ARCHIVO_ESTRUCTURA_BD = archivos.lista.find(a => a.ArchivoDeContenidoDeLaPaginaWebId == ID_ARCHIVO);
                archivos.archivosSeleccionados.push(ARCHIVO_ESTRUCTURA_BD);
            }
        },
        evtRemoverContenidosEnListaSeleccionados: function(e, rows, tipoCheck) {
            switch(tipoCheck) {
                case 'UNO':
                    this.contenidos.contenidosSeleccionados = this.contenidos.contenidosSeleccionados.filter(csel => csel.ContenidoDeLaPaginaWebId != rows.ContenidoDeLaPaginaWebId);
                    break;
                case 'MUCHOS':
                    // se remueven la paginacion de contenidos seleccionados
                    this.contenidos.contenidosSeleccionados = this.contenidos.contenidosSeleccionados.filter(csel => {
                        return !rows.some(crsel => {
                            return csel.ContenidoDeLaPaginaWebId == crsel.ContenidoDeLaPaginaWebId;
                        });
                    });
                    break;
                default:
                    break;
            }
        },
        evtRemoverArchivosEnListaSeleccionados: function(e, rows, tipoCheck) { 
            switch(tipoCheck) {
                case 'UNO':
                    this.formulario.archivos.archivosSeleccionados = this.formulario.archivos.archivosSeleccionados.filter(a => a.ArchivoDeContenidoDeLaPaginaWebId != rows.ArchivoDeContenidoDeLaPaginaWebId);
                    break;
                case 'MUCHOS':
                    if(this.campoRequeridoEsValido(rows))
                        // se remueven la paginacion de archivos seleccionados
                        this.formulario.archivos.archivosSeleccionados = this.formulario.archivos.archivosSeleccionados.filter(a => {
                            return !rows.some(ar => {
                                return a.ArchivoDeContenidoDeLaPaginaWebId == ar.ArchivoDeContenidoDeLaPaginaWebId;
                            });
                        });
                    else
                        this.formulario.archivos.archivosSeleccionados = [];
                    break;
                default:
                    break;
            }
        },
        persistirSwitchAContenidosActivos: async function() {
            if(this.contenidos.listaDeContenidos.length > 0) {
                this.contenidos.listaDeContenidos.forEach(cObj => {
                    const ID_SWITCH_ACTIVO_CONTENIDO = `check-contenido-activo-VEDC-${ cObj.ContenidoDeLaPaginaWebId }`;
                    //$("#" + ID_SWITCH_ACTIVO_CONTENIDO).trigger("click");
                    $("#" + ID_SWITCH_ACTIVO_CONTENIDO).prop('checked',  cObj.EstaActivo.activo);
                });
            }
        },
        llenarTablaResultados: async function(elementos) {
            this.limpiarContenidosSeleccionados();
            await Promise.resolve(this.darFormatoObjetosDeContenido(elementos));
            $("#tabla-contenidos").off("check.bs.table uncheck.bs.table check-all.bs.table uncheck-all.bs.table page-change.bs.table sort.bs.table");
            $("#tabla-contenidos").bootstrapTable({  data: this.contenidos.listaDeContenidos });      
            $("#tabla-contenidos").bootstrapTable('load',  this.contenidos.listaDeContenidos);  
            $('#tabla-contenidos').on('check.bs.table',(e, row) => {
                this.evtSeleccionoContenido(e, row);
            });
            $('#tabla-contenidos').on('uncheck.bs.table',(e, row) => {
                const TIPO_CHECK = 'UNO';
                this.evtRemoverContenidosEnListaSeleccionados(e, row,TIPO_CHECK);
            });
            $('#tabla-contenidos').on('check-all.bs.table',(e, rows) => {
                this.evtSeleccionoTodos(e, rows);
            });
            $('#tabla-contenidos').on('uncheck-all.bs.table',(e, rowsAfter, rowsBefore) => {
                const TIPO_CHECK = 'MUCHOS';
                this.evtRemoverContenidosEnListaSeleccionados(e, rowsBefore,TIPO_CHECK);
            });
            $('#tabla-contenidos').on('page-change.bs.table', (size, number) => {
                //console.log('entro::evento::');
                this.$nextTick(async () => {
                    await Promise.resolve(this.persistirSwitchAContenidosActivos());
                });
            });
            $('#tabla-contenidos').on('sort.bs.table', (name, order) => {
                this.$nextTick(async () => {
                    await Promise.resolve(this.persistirSwitchAContenidosActivos());
                });
            });
            // bs table no reconoce clases css del componenete, una vez que se cargan los datos se asigna las clases de de manera global 
            $("td[id^=switch-activo-inactivo-VEDC]").addClass('switch-contenido-activo-VEDC');
            $("td[id^=slider-activo-inactivo-VEDC]").addClass('slider-contenido-activo-VEDC');
        },
        formateadorHTMLAccionesContenidos: () => {
            return [
            '<div>',
            '<button id="editar-contenido-pw-SICPO" type="button" class="btn btn-sm btn-xs btn btn-info texto-ajustable align-middle align-center"><i class="fas fa-edit"></i>&nbsp;Editar</button>',
            /* '<button id="eliminar-contenido-pw-SICPO" type="button" class="btn btn-sm btn-xs btn-danger texto-ajustable align-middle align-center p-1"><i class="fas fa-trash" ></i></button>', */
            '</div>'
            ].join("");
        },
        formateadorHTMLAccionesArchivos: (tipoDeHTML) => {
            let srtHTML = '';
            switch(tipoDeHTML) {
                case 'DESCARGA':
                    srtHTML = [
                                '<div>',
                                '<button id="descargar-archivo-SICPO" type="button" class="btn btn-sm btn-xs btn btn-success texto-ajustable align-middle align-center"><i class="fas fa-file-download"></i>&nbsp;Descargar</button>',
                                '</div>'
                                ].join("");
                    break;
                case 'ACCIONES':
                    srtHTML = [
                                '<div>',
                                '<button id="editar-contenido-pw-SICPO" type="button" class="btn btn-sm btn-xs btn btn-info texto-ajustable align-middle align-center p-1 mr-2"><i class="fas fa-edit" ></i></button>',
                                '<button id="eliminar-contenido-pw-SICPO" type="button" class="btn btn-sm btn-xs btn-danger texto-ajustable align-middle align-center p-1"><i class="fas fa-trash" ></i></button>',
                                '</div>'
                                ].join("");
                    break;
            }
            return srtHTML;
        },
        evtCerrarFormulario: function() {
            $("#formulario-contenido").modal('hide');
            this.confirmarPerdidaDeModificaciones();
        },
        confirmarPerdidaDeModificaciones: function () {
            this.modalInformativo = {
                titulo: 'Mensaje del sistema',
                mensaje: `Si cierras el formulario se perderán las posibles modificaciones realizadas al contenido\n¿Desea continuar?`,
                funcionConfirmar: () => {
                    $("#modal-informativo").modal('hide');
                    let mensaje = '';
                    this.limpiarFormulario(mensaje);
                },
                funcionCancelar: () => {
                    $("#modal-informativo").modal('hide');
                    $("#formulario-contenido").modal('show');
                }
            }
            $("#modal-informativo").modal('show');
        },
        validacionesFormulario: function(tipoValidacion, mostrarEstatusDeValidacion) { 
            const { VALIDACIONES } = this.formulario;
            let pasoValidacion = false;
            let camposAvalidar = [];
            let errorMsj = null;
            switch(tipoValidacion) {
                case VALIDACIONES.agregarArchivoEnListado: 
                    const { vinculo, url, archivo } = this.formulario.archivos;
                    camposAvalidar.push({ input: vinculo, mensajeError: 'ingresar un texto del vinculo valido.' });
                    if(this.formulario.archivos.esVinculo) 
                        camposAvalidar.push({ input: url, mensajeError: 'ingresar un url valido' });
                    else 
                        camposAvalidar.push({ input: archivo, mensajeError: 'seleccionar un archivo valido' });

                    for(let i =0; i<camposAvalidar.length; i++) {
                        const INPUT = camposAvalidar[i];
                        if(!this.campoRequeridoEsValido(INPUT.input)) {
                            pasoValidacion = false;
                            errorMsj = `Debes ${ INPUT.mensajeError }`;
                            break;
                        }
                        else {
                            pasoValidacion = true;
                        }
                    }
                    break;
                case VALIDACIONES.agregarArchivoUrlEnListado: 
                    break;
                case VALIDACIONES.camposDeContenido: 
                    let camposRequeridosOrdenados = this.ordenarInputsRequeridosDeContenido();
                    console.log('camposRequeridosOrdenados::',camposRequeridosOrdenados);
                    for(let i =0; i<camposRequeridosOrdenados.length; i++) {
                        const INPUT = camposRequeridosOrdenados[i];
                        if(!this.campoRequeridoEsValido(INPUT.campo)) {
                            pasoValidacion = false;
                            errorMsj = `Debes ${ INPUT.mensaje }`;
                            break;
                        }
                        else {
                            pasoValidacion = true;
                        }
                    }
                    break;
                default: 
                    break;
            }
            if(mostrarEstatusDeValidacion) {
                this.formulario.mostrarErroresInput = !pasoValidacion;
                this.formulario.mensajeError = (pasoValidacion) ? null : errorMsj;
            }
            return pasoValidacion;
        },
        ordenarInputsRequeridosDeContenido: function() { 
            let camposRequeridosOrdenados = [];
            let input = {};
            if(this.inputRequerido.titulo.requerido) {
                input = {
                    campo: this.formulario.titulo,
                    mensaje: 'ingresar un título valido'
                }
                camposRequeridosOrdenados.push(input)
            }
            if(this.inputRequerido.nombrePresidente.requerido) {
                input = {
                    campo: this.formulario.nombrePresidente,
                    mensaje: 'ingresar un nombre del presidente valido'
                }
                camposRequeridosOrdenados.push(input); 
            }
            if(this.inputRequerido.catalogoPoderes.requerido) {
                input = {
                    campo: this.formulario.catalogoPoderes.valorDefinido,
                    mensaje: 'seleccionar quien designa'
                }
                camposRequeridosOrdenados.push(input);
            }
            if(this.inputRequerido.rangoPresidente.requerido) {
                input = {
                    campo: this.formulario.rangoPresidente,
                    mensaje: 'ingresar un periodo de tiempo valido'
                }
                camposRequeridosOrdenados.push(input); 
            }
            if(this.inputRequerido.textoDelContenido.requerido) {
                input = {
                    campo: this.formulario.descripcion,
                    mensaje: 'ingresar una descripción valida'
                }
                camposRequeridosOrdenados.push(input); 
            }
            if(this.inputRequerido.imagenDeContenido.requerido) {
                input = {
                    campo: this.formulario.imagenDeContenido.archivo,
                    mensaje: 'ingresar una imagen del contenido valida'
                }
                camposRequeridosOrdenados.push(input);
            }
            if(this.inputRequerido.imagenesObligaciones.requerido){
                input = {
                    campo: this.formulario.imagenesObligaciones.imagenSeleccionada,
                    mensaje: 'seleccionar una imagen de obligacion'
                }
                camposRequeridosOrdenados.push(input);
            }
            if(this.inputRequerido.archivosDeContenido.requerido) {
                if(this.inputRequerido.listaDeArchivos.requerido) {
                    if(this.formulario.archivos.lista.length < 1 && this.formulario.archivos.descargaRadio) {
                            let mensajeError = (this.formulario.archivos.descargaRadio) ? 'seleccionar un archivo valido' : 'ingresar un vínculo del archivo valido';
                            input = {
                                campo: null,
                                mensaje: mensajeError
                            }
                            camposRequeridosOrdenados.push(input);
                    }
                    else if(this.formulario.archivos.esVinculo){
                        input = {
                            campo: this.formulario.archivos.vinculo,
                            mensaje: 'ingresar un vinculo de la pagina valido'
                        }
                        camposRequeridosOrdenados.push(input);
                    }
                } // lista de archivos requerido
                else {
                    if(this.formulario.archivos.descargaRadio) {
                        input = {
                            campo: this.formulario.archivos.vinculo,
                            mensaje: 'ingresar un texto del vinculo valido'
                        }
                        camposRequeridosOrdenados.push(input);
                        input = (!this.formulario.archivos.esVinculo) ? {
                            campo: this.formulario.archivos.archivo,
                            mensaje: 'seleccionar un archivo valido'
                        } : { 
                            campo: this.formulario.archivos.url,
                            mensaje: 'ingresar un url valido'
                        }
                        camposRequeridosOrdenados.push(input);
                    }
                    if(this.formulario.vinculo.vinculoRadio) {
                        input = {
                            campo: this.formulario.vinculo.texto,
                            mensaje: 'ingresar un texto del vinculo valido'
                        }
                        camposRequeridosOrdenados.push(input);
                        input = {
                            campo: this.formulario.vinculo.url,
                            mensaje: 'un vínculo del archivo valido'
                        }
                        camposRequeridosOrdenados.push(input);
                    }
                }
            } // con archivo requerido
            if(this.formulario.esDisposicionEspecial) {
                input = {
                    campo: this.formulario.catalogoSubmenu.valorDefinido,
                    mensaje: 'selccionar un tipo de submenu valido.'
                }
                camposRequeridosOrdenados.push(input);

                input = {
                    campo: this.formulario.tituloSubMenu,
                    mensaje: 'ingresar un titulo para la disposicion especial valido'
                }
                camposRequeridosOrdenados.push(input);
            }
            return camposRequeridosOrdenados;
        },
        validarVinculoURL: function(vinculo) {
            let pattern = new RegExp('^(https?:\\/\\/)?'+ // protocolo
                '((([a-z\\d]([a-z\\d-]*[a-z\\d])*)\\.)+[a-z]{2,}|'+ // nombre del dominio
                '((\\d{1,3}\\.){3}\\d{1,3}))'+ // ip
                '(\\:\\d+)?(\\/[-a-z\\d%_.~+]*)*'+ // puerto y ruta
                '(\\?[;&a-z\\d%_.~+=-]*)?'+ // query de la peticion
                '(\\#[-a-z\\d_]*)?$','i'); // localizador de fragmentos
            let vinculoValido = !!pattern.test(vinculo);
            if(!vinculoValido)
                comun.mensajeDeAlerta('El vinculo no es valido,<br> por favor ingrese un vinculo valido, ejemplo www.vinculoPrueba.com');

            return vinculoValido;
        },
        campoRequeridoEsValido: function(campo) { 
            let esValido = false
            if(typeof campo === 'string' || campo instanceof String) {
                // valida que filtro tipo cadena no sea nula, indefinida y compuestas solo de espacios en blanco o saltos de linea
                if (campo != null && campo != undefined && campo != '' && campo.replace(/\s/g, '').length) {
                    esValido = true;
                }
            }
            else if (typeof campo === 'number' || campo instanceof Number) {
                // valida que filtro tipo numerico no sea nulo, indefinido y que tengan una valor definido valido (diferente a -1)
                if (campo != null && campo != undefined && campo > 0) {
                    esValido = true;
                }
            }
            else {
                if (campo != null && campo != undefined) {
                    esValido = true;
                }
            }
            return esValido;
        },
        asignarPrioridadACamposDeFormulario: async function(id,campoDeFormulario,identificarPorSeccion) { 
            let reglasDeCampo = {
                opcional: false,
                requerido: false
            };
            let idPaginasWeb      = [];
            let idSecciones       = [];
            let arregloIdComparar = [];
            switch(campoDeFormulario) {
                case 'textoDelContenido':
                    idPaginasWeb   = [12,5,7,8,9,10,16,18,22,23,24,25,26,27,28,34,35,45,54,4];
                    idSecciones    = [3,29,45,154,155,156,157,120,121,124,125,128,129,133,134,136,138,140,142,143,144,146,147,179,249,219,255];
                    arregloIdComparar = identificarPorSeccion ? idSecciones : idPaginasWeb;
                    // comparacion con negacion, incluir en arreglos de paginasWeb y secciones el id de los elementos que no cargaran el campo textoDelContenido
                    if(!this.compararListaDeId(id,arregloIdComparar)) {
                        reglasDeCampo.requerido = true;
                    }
                    break;
                case 'textoDelVinculo':
                    idPaginasWeb = [1,4,5,6,9,19,20,21,41,43,44,49,52,53,39,54,57];
                    idSecciones = [];
                    arregloIdComparar = identificarPorSeccion ? idSecciones : idPaginasWeb;
                    if(this.compararListaDeId(id,arregloIdComparar)) {
                        reglasDeCampo.requerido = true;
                    }
                    break;
                case 'archivosDeContenido':
                    idPaginasWeb = [1,3,5,7,8,9,10,17,19,20,21,22,23,24,25,26,27,29,14,28,34,35,41,43,44,45,49,52,53,39,54,57,61,4];
                    idSecciones = [29,45,83,84,85,86,87,88,89,90,95,96,97,98,99,100,101,102,117,118,119,120,121,122,123,124,125,126,127,128,129,130,131,132,133,134,135,136,137,138,139,140,141,142,143,144,145,146,147,66,67,68,69,70,71,72,73,74,75,76,77,78,154,155,156,157,167,168,169,170,171,172,173,174,179,204,205,206,207,305];
                    arregloIdComparar = identificarPorSeccion ? idSecciones : idPaginasWeb;
                    if(this.compararListaDeId(id,arregloIdComparar)) {
                        reglasDeCampo.requerido = true;
                    }
                    break;
                case 'vinculo':
                    idPaginasWeb = [5,9,54];
                    idSecciones = [];
                    arregloIdComparar = identificarPorSeccion ? idSecciones : idPaginasWeb;
                    if(this.compararListaDeId(id,arregloIdComparar)) {
                        reglasDeCampo.requerido = true;
                    }
                    break;
                case 'titulo':
                    idPaginasWeb = [19,20,21];
                    idSecciones = [];
                    arregloIdComparar = identificarPorSeccion ? idSecciones : idPaginasWeb;
                    if(this.compararListaDeId(id,arregloIdComparar)) {
                        reglasDeCampo.requerido = true;
                    }
                    break;
                case 'imagenDeContenido':
                    idPaginasWeb = [12,19,20,21];
                    idSecciones = [];
                    arregloIdComparar = identificarPorSeccion ? idSecciones : idPaginasWeb;
                    if(this.compararListaDeId(id,arregloIdComparar)) {
                        reglasDeCampo.requerido = true;
                    }
                    break;
                case 'opcionesComunicadoUrgente':
                    idPaginasWeb = [19];
                    idSecciones = [];
                    arregloIdComparar = identificarPorSeccion ? idSecciones : idPaginasWeb;
                    if(this.compararListaDeId(id,arregloIdComparar)) {
                        reglasDeCampo.requerido = true;
                    }
                    break;
                case 'fechaDePublicacion':
                    idPaginasWeb = [1,2,3,4,5,6,7,8,9,10,11,12,13,14,15,16,17,18,19,20,21,22,23,24,25,26,27,28,29,34,35,41,43,44,45,52,54,57,61];
                    idSecciones = [3,28,45,29,83,84,85,86,87,88,89,90,95,96,97,98,99,100,101,102,117,118,119,120,121,122,123,124,125,126,127,128,129,130,131,132,133,134,135,136,137,138,139,140,141,142,143,144,145,146,147,66,67,68,69,70,71,72,73,74,75,76,77,78,148,154,155,156,157,167,168,169,170,171,172,173,174,179,204,205,206,207,305];
                    arregloIdComparar = identificarPorSeccion ? idSecciones : idPaginasWeb;
                    if(this.compararListaDeId(id,arregloIdComparar)) {
                        reglasDeCampo.requerido = true;
                    }
                    break;
                case 'fechaDePublicacionFinal':
                    idPaginasWeb = [19];
                    idSecciones = [];
                    arregloIdComparar = identificarPorSeccion ? idSecciones : idPaginasWeb;
                    if(this.compararListaDeId(id,arregloIdComparar)) {
                        reglasDeCampo.requerido = true;
                    }
                    break;
                case 'listaDeArchivos':
                    idPaginasWeb = [];
                    idSecciones = [83,84,85,86,87,88,89,90,95,96,97,98,99,100,101,102,117,118,119,122,123,126,127,130,131,132,135,137,139,141,145,66,67,68,69,70,71,72,73,74,75,76,77,78,167,168,169,170,171,172,173,174,168,170,172,174,204,205,206,207];
                    arregloIdComparar = identificarPorSeccion ? idSecciones : idPaginasWeb;
                    if(this.compararListaDeId(id,arregloIdComparar)) {
                        reglasDeCampo.requerido = true;
                    }
                    break;
                case 'rangoPresidente':
                    idPaginasWeb = [12];
                    idSecciones = [];
                    arregloIdComparar = identificarPorSeccion ? idSecciones : idPaginasWeb;
                    if(this.compararListaDeId(id,arregloIdComparar)) {
                        reglasDeCampo.requerido = true;
                    }
                    break;
                case 'nombrePresidente':
                    idPaginasWeb = [4,6,12];
                    idSecciones = [3];
                    arregloIdComparar = identificarPorSeccion ? idSecciones : idPaginasWeb;
                    if(this.compararListaDeId(id,arregloIdComparar)) {
                        reglasDeCampo.requerido = true;
                    }
                    break;
                case 'disposicionEspecial':
                    idPaginasWeb = [19,28];
                    idSecciones = [179];
                    arregloIdComparar = identificarPorSeccion ? idSecciones : idPaginasWeb;
                    if(this.compararListaDeId(id,arregloIdComparar)) {
                        reglasDeCampo.requerido = true;
                    }
                    break;
                case 'archivoConVinculo':
                    idPaginasWeb = [];
                    idSecciones = [];
                    arregloIdComparar = identificarPorSeccion ? idSecciones : idPaginasWeb;
                    reglasDeCampo.requerido = true;
                    break;
                case 'imagenesObligaciones':
                    idPaginasWeb = [];
                    idSecciones = [83,84,85,86,87,88,89,90,95,96,97,98,99,100,101,102,167,168,169,170,171,172,173,174,204,205,206,207];
                    arregloIdComparar = identificarPorSeccion ? idSecciones : idPaginasWeb;
                    if(this.compararListaDeId(id,arregloIdComparar)) {
                        reglasDeCampo.requerido = true;
                        if(this.formulario.imagenesObligaciones.lista.length < 1)
                            await Promise.resolve(this.obtenerImagenesObligaciones());
                    }
                    break;
                case 'catalogoPoderes': 
                    idPaginasWeb = [];
                    idSecciones = [3];
                    arregloIdComparar = identificarPorSeccion ? idSecciones : idPaginasWeb;
                    if(this.compararListaDeId(id,arregloIdComparar)) {
                        reglasDeCampo.requerido = true;
                    }
                    break;
                default:
            }
            return reglasDeCampo;
        },
        compararListaDeId: function(idAComparar, listaDeId) {
            return listaDeId.some(id => id == idAComparar);;
        },
        paginaRequiereComunicado: function(id) { 
            let esComunicado = false;
            const PAGINA_NOTICIAS_ID = 19;
            const BOLETINES_INFORMATIVOS_ID = 20;
            const FOTONOTAS = 21;
            const COMUNICADOS = [PAGINA_NOTICIAS_ID, BOLETINES_INFORMATIVOS_ID, FOTONOTAS];
            esComunicado = COMUNICADOS.some(c => c == id);
            return esComunicado;
        },
        esVinculoPredeterminado: function() { 
            let esPredeterminado = false;
            if(this.campoRequeridoEsValido(this.inputRequerido)) {
                const CONVOCATORIAS_ID = 3;
                const BOLETINES_ELECTRONICOS = 29;
                if(this.inputRequerido.tipoDeFormulario == 'comunicado')
                    esPredeterminado = true;
                else if(this.contenidos.filtrosBusqueda != null) {
                    if(this.contenidos.filtrosBusqueda.paginaWebId == CONVOCATORIAS_ID || this.contenidos.filtrosBusqueda.paginaWebId == BOLETINES_ELECTRONICOS)
                        esPredeterminado = true;
                }
            }
            this.formulario.esTextoDeVinculoPredeterminado = esPredeterminado;
        }
    },
    mounted() {
        this.$nextTick(() => {
            $("#tabla-contenidos").bootstrapTable({  data: this.contenidos.listaDeContenidos });      
            $("#tabla-contenidos").bootstrapTable('load',  this.contenidos.listaDeContenidos); 
        });
        window.operateEvents = {
            "click #editar-contenido-pw-SICPO": (e,val,row,index) => {          
                this.evtMostrarFormulario(row);
            },
            "click #eliminar-contenido-pw-SICPO": (e,val,row,index) => {          
                this.evtEliminarContenido(row)
            },
            "click #eliminar-archivo-pw-SICPO": (e,val,row,index) => {          
                $("#tabla-archivos-contenido").bootstrapTable('remove', {
                    field: 'RutaDelArchivo',
                    values: [row.RutaDelArchivo]
                });
                this.formulario.archivos.identificadoresDeArchivos = this.formulario.archivos.identificadoresDeArchivos.filter(ia => ia.llave != row.RutaDelArchivo);
                this.$nextTick(async () => {
                    await Promise.resolve(this.persistirSwitchArchivosActivos());
                });
                /* console.log('archivos::',this.formulario.archivos.lista);
                console.log('identificadores::',this.formulario.archivos.identificadoresDeArchivos); */
            },
            "click #descargar-archivo-SICPO": (e,val,row,index) => {   
                if(row.ArchivoDeContenidoDeLaPaginaWebId > 0)       
                    this.evtDescargarArchivo(row.RutaDelArchivo)
                else
                    this.evtDescargarArchivoEnMemoria(row);
            },
            'click :checkbox[id^=check-contenido-activo-VEDC]': (e, value, row, index) => {
                this.evtCambiarEstatusContenidoIndividual(e,row);
            },
            'click :checkbox[id^=check-archivo-activo-VEDC]': (e, value, row, index) => {
                this.evtCambiarEstatusDeArchivo(e,row);
            },
            'click .icono-ampliar-texto': (e, value, row, index) => {
                this.mostrarTextoDeContenidoCompleto(row, index);
            },
        };
       /*  $("#tabla-contenidos").bootstrapTable({  data: this.lista });      
        $("#tabla-contenidos").bootstrapTable('load',  this.lista);  */
    },
    computed: {
        folioContenido() {
            return (this.campoRequeridoEsValido(this.contenidos.contenidoSeleccionado)) ? 
                `Contenido [#Folio: ${ this.contenidos.contenidoSeleccionado.ContenidoDeLaPaginaWebId }]` : ``;
        },
        inputRequerido() {
            return this.formulario.camposRequeridosFormulario;
        },
        seccionDeContenidos() {
            return (this.campoRequeridoEsValido(this.contenidos.filtrosBusqueda)) ? 
                `${ this.contenidos.filtrosBusqueda.nombreSeccion }` : ``;
        },
        textoDescriptivoContenido() {
            return (this.contenidos.mostrarTextoDelVinculo) ? 'Texto del vinculo' : 'Texto del contenido';
        },
        activarVariosContenidos() {
            return this.esActivacionMultipleContenidos;
        }
    }
}
</script>
<style scoped>
.acciones-activacion-contenidos .btn-block{
    height: 45px;
    background-color: black;
}

.icono-activacion-contenidos {
    font-size : 4vw;
}

.cambio-multiple-archivos-activacion {
    cursor: pointer;
    font-size: 2em;
} 

#contenedor-error-formulario {
    padding: 1em;
    background-color: #26272b;
    border: 1px solid #5c5959;
    border-radius: 8px;
    margin-bottom: 1em;;
}

.lista-contenidos {
    overflow: hidden;
    overflow-y:scroll;
    max-height: 500px;
}

.btn-block {
    cursor: pointer;
}

#formulario-contenido .modal-lg {
    max-width: 50% !important;
}

.contenedor-color-negro {
    padding: 1.5em;
    background-color: #2c2d31;
    box-shadow: 0px 6px 20px 8px #161616;
}

#formulario-contenido .modal-header {
    background-color: rgb(36, 34, 34);;
    border: none;
}

#modal-informativo .modal-lg {
    max-width: 30% !important;
}

#modal-informativo .modal-header {
    background-color: rgb(36, 34, 34);;
    border: none;
}

/* #modal-ordenamiento-contenidos .modal .modal-content{
    overflow:hidden;
}
#modal-ordenamiento-contenidos .modal-body{
    overflow-y:scroll;
} */

#modal-cambio-estatus .modal-lg {
    max-width: 25% !important;
}

#modal-cambio-estatus .modal-header {
    background-color: rgb(36, 34, 34);;
    border: none;
}

#modal-ordenamiento-contenidos .modal {
    max-width: 20% !important;
}

#modal-ordenamiento-contenidos .modal-lg {
    max-width: 50% !important;
}

#modal-ordenamiento-contenidos .modal-header {
    background-color: rgb(36, 34, 34);;
    border: none;
}

#formulario-contenido .btn-group-toggle{
    margin-bottom: 1em;
}

#formulario-contenido .btn-secondary:not(:disabled):not(.disabled).active, .btn-secondary:not(:disabled):not(.disabled):active, .show>.btn-secondary.dropdown-toggle {
    color: white;
    background-color: #57585B;
    border-color: white;
}
#formulario-contenido .btn-secondary {
    color: rgb(106, 108, 112);
    background-color: #323335;
    border-color: rgb(106, 108, 112);
    font-size: 0.95rem;
}

#formulario-contenido .btn-secondary:hover {
    color: white;
    background-color: #323335;
    border-color: white;
}

.texto-ajustable {
     font-size : 100px !important;
     margin-right: 0px !important;
}

#editar-contenido-pw-SICPO .btn-sm {
    width: 5px !important;
}

#tabla-resultados-edicion-SICPO {
    background-color: #323335;
    padding: 25px;
}

#titulo-resultados {
    background-color: #1b1919;
    padding: 13px;
    padding-left: 33px;
    padding-right: 26px;
    margin-bottom: 0px;
}

#tabla-resultados-edicion-SICPO table {
    table-layout: fixed;
    width: 100%;
    word-wrap:break-word;
}


#accion-estatus-contenidos h6:hover, #accion-estatus-contenidos h6:focus {
    text-decoration-line: underline;
    font-weight: bold;
    cursor: pointer;
}

/* SWITCH PARA INDICAR CONTENIDO ACTIVO O INACTIVO */
.switch {
  position: relative;
  width: 60px;
  height: 34px;
}

.switch input {display:none;}

.slider {
  position: absolute;
  cursor: pointer;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: #ca2222;
  -webkit-transition: .2s;
  transition: .2s;
   border-radius: 34px;
}

.slider:before {
  position: absolute;
  content: "";
  height: 26px;
  width: 26px;
  left: 4px;
  bottom: 4px;
  background-color: white;
  -webkit-transition: .2s;
  transition: .2s;
  border-radius: 50%;
}

.switch input:checked + .slider {
  background-color: #2ab934;
}

.switch:focus + .slider {
  box-shadow: 0 0 1px #2196F3;
}

.switch input:checked + .slider:before {
  -webkit-transform: translateX(25px);
  -ms-transform: translateX(25px);
  transform: translateX(25px);
}

.slider:after
{
 content:'';
 color: white;
 display: block;
 position: absolute;
 transform: translate(-50%,-50%);
 top: 50%;
 left: 50%;
 font-size: 10px;
 font-family: Verdana, sans-serif;
}

.switch input:checked + .slider:after
{  
  content:'';
}

</style>

<style>
/* SWITCH PARA INDICAR CONTENIDO ACTIVO O INACTIVO */
.switch-contenido-activo-VEDC {
  position: relative;
  top: 5px;
  width: 40px;
  height: 24px;
}

.switch-contenido-activo-VEDC input {display:none;}

.slider-contenido-activo-VEDC {
  position: absolute;
  cursor: pointer;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: #ca2222;
  -webkit-transition: .2s;
  transition: .2s;
   border-radius: 34px;
}

.slider-contenido-activo-VEDC:before {
  position: absolute;
  content: "";
  height: 16px;
  width: 16px;
  left: 4px;
  bottom: 4px;
  background-color: white;
  -webkit-transition: .2s;
  transition: .2s;
  border-radius: 50%;
}

.switch-contenido-activo-VEDC input:checked + .slider-contenido-activo-VEDC {
  background-color: #2ab934;
}

.switch-contenido-activo-VEDC input:focus + .slider-contenido-activo-VEDC {
  box-shadow: 0 0 1px #2196F3;
}

.switch-contenido-activo-VEDC input:checked + .slider-contenido-activo-VEDC:before {
  -webkit-transform: translateX(15px);
  -ms-transform: translateX(15px);
  transform: translateX(15px);
}

.slider-contenido-activo-VEDC:after
{
 content:'';
 color: white;
 display: block;
 position: absolute;
 transform: translate(-50%,-50%);
 top: 50%;
 left: 50%;
 font-size: 10px;
 font-family: Verdana, sans-serif;
}

.switch-contenido-activo-VEDC input:checked + .slider-contenido-activo-VEDC:after
{  
  content:'';
}

/* dropdown tabla de contenidos */
#tabla-resultados-edicion-SICPO .search {
    width: 20rem;
}

#tabla-resultados-edicion-SICPO .dropdown-toggle {
    width: 3.3rem;
}

/* #tabla-resultados-edicion-SICPO .pagination > li > a {
    background-color: white;
    color: #121213;
}

#tabla-resultados-edicion-SICPO > li > a:focus,
#tabla-resultados-edicion-SICPO > li > a:hover,
#tabla-resultados-edicion-SICPO > li > span:focus,
#tabla-resultados-edicion-SICPO .pagination > li > span:hover
{
    color: #111011;
    background-color: #eee;
    border-color: #ddd;
}

#tabla-resultados-edicion-SICPO .pagination > .active > a {
    color: white;
    background-color:  black;
    border: solid 1px #39373d;
}

#tabla-resultados-edicion-SICPO .pagination > .active > a:hover {
    background-color:  black;
    border: solid 1px #39373d;
} */
</style>



// WEBPACK FOOTER //
// src/components/SICPO/PaginaWeb/EdicionDeContenido/CEdicionDeContenido.vue